import { TUTORIAL_MESSAGES_EN } from './message-tutorial.utils';

export const MESSAGE_EN = {
  button: {
    loading: "...",
    filter: "Filters",
    login: "Login",
    confirm: "Confirm",
    save: "Save",
    edit: "Edit",
    view: "View",
    copy: "Copy",
    add: "Add",
    save_draft: "Save draft",
    valid: "Validate",
    delete: "Delete",
    delete_version: "Delete version",
    modif: "Modify",
    assign: "Assign",
    continue: "Continue",
    import: "Import",
    print: "Print",
    send: "Send",
    precedent: "Previous",
    next: "Next",
    close: "Close",
    cancel: "Cancel",
    cancel_modif: "Cancel modification",
    ordonner: "Order",
    reset: "Reset",
    searchArticleLot: "Article, lot....",
    select: "Select",
    selected: "Selected",
    drag_drop:
      "Drag and drop your documents here... (image and PDF formats only)",
    browse_files: "... or browse your files",
    more_param: "More parameters",
    less_param: "Less parameters",
    refresh: "Refresh",
    invalid: {
      default: "You have errors in the form",
      stepperError: "You have steps with errors",
      noFiles: "No file selected",
      selectOne: "Please select at least one item",
      selectCommande: "Please select an order",
      selectPalette: "Please select at least one shipping unit",
      commandeCreate: "Please select a supplier and an address",
      noMouvement: "Please enter at least one movement",
      receptionInvalid:
        "You have incomplete receptions. Please finish the entry or remove the extra items",
      dechargementInvalid: "You have invalid unloadings",
      enregistrementInvalid: "You have invalid records",
      commentOrDocument: "You must provide at least one comment or document",
      ean13: "You can only create an article with an EAN13",
      pdcRetour: "You have invalid WIP returns",
      noArticle: "No article in the bill of materials",
      noProcess: "No process in the bill of materials",
      processNotPending:
        "Cancellation is impossible because some operations have already started.",
      stepNomenclature: "Please enter a lot for this article",
      ofWithoutLot: "The MO does not have a valid lot yet.",
      endOpe: "Please enter an evaluation",
    },
  },
  system: {
    network_error: "Network problem detected",
    check_connexion: "Please check your internet connection",
    browser_version: "Incompatible browser version",
    browser_version_update: "Please update your browser",
  },
  sideNav: {
    header: {
      infos: "Master data",
      daily_todo: "Daily tasks",
      inventaire: "Logistics",
      production: "Production",
      commandes: "Orders",
      administration: "Administration",
    },
    menu: {
      mouvements: "Stock movements",
      todo: "Task lists",
      inventaire: "Inventories",
      specifications_to_treat: "Specifications to process",
      dashboard: "Dashboard",
      documents: "Documents",
      articles: "Articles",
      production: "Productions",
      stock: "Stock",
      personnel: "Personnel",
      controles: "Controls to perform",
      ofs: "Manufacturing orders (MO)",
      models: "Specification templates",
      etapes: "Product specifications",
      commandes: "Supplier orders",
      commandes_client: "Customer orders",
      preparation: "Order preparation",
      of_plannif: "Planning",
      of_plannif_composant: "Component planning",
      ligne: "Production lines",
      info_journalieres: "Time entry",
      tiers: "Suppliers and customers",
      article_param: "Article specification",
      activite_param: "Activity settings",
      admin_param: "Administrative settings",
      user_param: "User settings",
      administration: "Administration",
      suivi_production: "Production tracking",
      stats_prod: "Statistics",
      dechargements: "Unloadings & Receptions",
      expeditions: "Shipments",
      equipes: "Team management",
      analyse: "Analysis",
      justup_billing: "JustUp billing",
      factures: "Invoices and credit notes",
      transferts: "Transfers",
    },
    privacy_policy: "Privacy policy",
  },
  tutorial: TUTORIAL_MESSAGES_EN,
  billing: {
    START_OF: "Start",
    END_OF: "End of production",
    RESTART_OF: "Production restart",
    START_OPE: "Start of production operation",
    END_OPE: "End of production operation",
    CONTROLE_OPE: "Control performed on production operation",
    PEO_VALID: "Validation of a process step on the production operation",
    of_of: "of MO",
  },
  documents: {
    title: "Documents",
    empty: "No document",
    uploading: "Uploading...",
    initing: "Initializing...",
    processing: "Preparing video...",
    select: "Select a file",
    import: "Import a file",
    remote_photo: "Take a photo",
  },
  specification: {
    create: "New version",
    send: "Request validation",
    validate: "Validate compliance",
    approuve: "Use this version",
    duplicate_path: "Duplicate",
    create_etape: "Create a specification",
    master_etapes: "Product specifications",
    etats: "States",
    specifs_archivees: "Archived specifications",
    editing: "Being modified...",
    tips_variables:
      "A parameter is data (text or number) that you can define once and reuse in your processes and controls via the dynamic text function.\n" +
      "\n" +
      'Example: if several steps of your process refer to a cooking time, create a "Cooking time" parameter. You can then call it directly without having to re-enter it each time.\n' +
      "\n" +
      "Less repetitive work\n" +
      "Less risk of forgetting or errors\n" +
      "More clarity and consistency in your specifications",
    demandes_modifications: "Modification requests",
    nouvelles_demandes: "New requests:",
    demandes_traitees: "Processed requests:",
    refuser: "Reject",
    autres_versions: "Other versions",
    version_courante: "Current version",
    en_redaction: "Being drafted",
    archive_tooltip: "An archived article no longer appears in searches",
    archive_label: "Archived",
    importer_specif: "Import from another specification",
    archiver: "Archive",
    desarchiver: "Unarchive",
    voir_specification: "View specification",
    consulter_specification: "View specification",
    creer_etape_enfant: "Create child step",
    demander_modification: "Request a modification",
    du: "From",
    au: "to",
    proprietaire: "Owner",
    code_client: "Customer code",
    afficher_plannificateur: "Show planner",
    specif_produit: "Product specification",
    demander_modif: "Request a modification",
    voir_specif: "View specification",
    consulter_specif: "View specification",
    duplicate: {
      warningProcesses: "All existing processes will be replaced",
      warningNomenclature:
        "Bill of materials articles will be added to the existing bill of materials",
      warningControles: "All existing controls will be replaced",
    },
  },
  cta: {
    fill: "Please fill it in",
  },
  palette: {
    title: "Shipping unit manager",
    add_label: "Create a shipping unit",
    create: "Create a shipping unit",
    edit: "Edit shipping unit",
    for_commande: "Shipping units for the customer order",
    add_lot_cta: "Please select the lot and quantity to add to the package",
    add_lot: "Select the lot to place on the shipping unit",
    livraison_no_expe: "Direct delivery / kept in stock",
    preparation: "Shipping unit preparation",
    see_other_for_commande: "View other packages for this order",
    warning_no_lines: "To prepare a shipping unit, please add at least one order line",
    palettes_selectionnees: "shipping units selected",
    palette_selectionnee: "shipping unit selected",
    expedier: "Ship",
    stock_support: "Available stock",
    stock_support_unit: "unit(s) in stock",
    stock_support_insufficient: "Insufficient stock for this support article in the selected warehouse",
    stock_support_go_to_stock: "View stocks",
    stock_support_lot: "Support article lot",
    stock_support_select_lot: "Select a lot for the support article",
  },
  commandes_client: {
    send_mail: "Send confirmation to customer",
  },
  commandes: {
    command: "Order",
    send_mail: "Send order to supplier",
    terminer: "Mark as completed",
    expedier: "Ship",
    prete: "Mark as ready",
    preparer: "Prepare order",
    creation: "Supplier order creation",
    createur: "Created by",
    passer: "Place order",
    solder: "Settle",
    annuler: "Cancel",
    modifier: "Modify order",
    from: "Choose",
    article: "an article",
    fournisseur: "a supplier",
    add_label: "Add an order",
    for: "Order for",
    confirmer: "Confirm",
    confirmer_the: "Confirm the order",
    recevoir: "Reception",
    recevoir_the: "Order reception",
    details: "Update the order",
    add_new_articles: "Adding new articles to the order",
    dateLivraison: "Delivery date",
    resume: "Orders summary",
    createCommandes: "Create #nb orders",
    noCommand: "No order to display",
    noArticle: "No article",
    aucune_reception: "No reception for this order",
    livreeLe: "Delivered on: ",
    delaiLivraison: "Delivery lead time",
    dateLivraisonAlert:
      "The delivery lead time for this article pushes back the delivery date",
    dateLivraisonManuelleAlert:
      "The order delivery date is manual, however the article delivery lead time is #delai days. Do you want to change the order delivery date?",
    confirmMulti: "#nb order created.",
    confirmMulti_plural: "#nb orders created.",
    createMulti: "Create #nb order",
    createMulti_plural: "Create #nb orders",
    createSingle: "Create this order",
    confirmSingle: "Order created successfully",
    errorSingle: "Error creating the order",
    lot_obligatoire: "Supplier lot required",
    lot_obligatoire_desc:
      "This article requires traceability. Please enter the lot number.",
    multiple_info: "Multiple of #multiple #unite",
    multiple_ok: "#factor × #multiple #unite",
    multiple_hint: "Multiple of #multiple #unite — round to:",
    multiple_keep: "keep #qty",
  },
  commande_client: {
    creation: "Customer order creation",
    createur: "Created by",
    passer: "Place order",
    modifier: "Modify order",
    from: "Choose",
    article: "an article",
    fournisseur: "a supplier",
    add_label: "Add an order",
    for: "Order for",
    qtt_livre: "Delivered quantity",
    join_bill: "Attach proforma invoice",
    join_confirmation: "Attach order confirmation",
    lignesDeCommande: "Order lines",
    preparationVrac: "Bulk preparation",
    creerNouvellePalette: "Create a new shipping unit",
    expedierVrac: "Ship",
    ajouterDesLots: "Add lots",
    ajouterLignesAvant: "Please add lines to the order first",
    expeditionDu: "Shipment of",
    imprimerBL: "Print delivery note",
    envoyerVersChargement: "Send to loading",
    preparation: "Preparation",
    palettes: "Shipping units",
    vrac: "Lots without shipping units",
    paletteDu: "Shipping unit ·",
    vracDu: "Bulk ·",
    mettreSurPalette: "Put on shipping unit",
    choisirArticle: "Click on an article to add lots",
    enZone: "In area",
    surPalette: "On shipping unit",
    aide_expedition_maker:
      "Select an article to choose the lots and quantities to add to the shipping unit. The progress bar shows advancement relative to the requested quantity.",
    voir_proforma: "View proforma invoice",
    proforma_rib_title: "Choose the bank details to display on the proforma",
    voir_confirmation: "View order confirmation",
  },
  search: {
    label: "Search here ...",
    main_bar: "Search for an article, a third party, an order...",
  },
  ligne_param: {
    label: "Line settings",
    add_cta: "Add a setting",
    create_label: "Creating a new setting",
    edit_label: "Editing the setting",
    no_param: "No setting has been configured.",
  },
  mouvement: {
    pending_to_save: "Movements to save",
  },
  of: {
    voir_of: "View MO",
    epingle: "Pinned",
    creer_of: "Create a MO",
    why_delete:
      "You can only delete a MO if it has no operations in progress or already completed.",
    withQuantiteOpe: "Track quantities produced per operation.",
    chose_other: "Select another MO",
    end: "Complete the MO",
    list: "MO list",
    add_cta: "Add a MO",
    reinte_and_end: "Reintegrate and finish the MO",
    confirmation_mouvement: "Confirm movements for the ",
    no_ope: "No operation on this MO",
    bilan_matieres_intermediaire: "With intermediate material balances",
    auto_plan: "Auto-plan",
    prepare_opes: "Preparing operations",
    quantiteParOpe: "Quantity per operation",
    missing_precondition_text:
      "Before starting a manufacturing order, you must first configure a production line and an article.",
    missing_precondition_text_article: "Create your first article",
    missing_precondition_text_ligne: "Create your first production line",
    no_current_specif1: "The specification of",
    no_current_specif2: "is not validated",
    select_of: "Please select a MO",
    specifOutdated1: "The specification has been modified.",
    specifOutdated2: "Do you want to update the MO?",
    regenerateOpe: "Update",
    confirmUpdateSpecif: "Updating the MO specification",
    selectParam: "Please select a line parameter",
    stockOutDated1:
      "You have end-of-line articles that are no longer in the bill of materials.",
    stockOutDated2: "This operation will reintegrate them.",
    stockOutDatedQtt: "End-of-line quantity",
    cancel: "Cancel the MO",
    cancel_impossible:
      "Cannot cancel the MO because operations are in progress",
    cancel_confirm: "You are about to cancel MO #numero. Do you confirm?",
    prepare_pdc: "Prepare WIP",
    reintegrer_pdc: "Reintegrate WIP",
    du: "From",
    au: "To",
    match_date: "Matches date",
    quantity_produced: "Quantity produced:",
  },
  bilan_matiere: {
    why_disabled:
      "To enter the material balance, please complete at least one production operation",
  },
  heures: {
    empty: "No hours recorded on this MO",
  },
  users: {
    edit: "Edit",
    activate: "Reactivate",
    deactivate: "Deactivate",
    go_profile: "Profile",
    showDisabled: "Show deactivated users",
    status_all: "All",
    status_active: "Active",
    status_inactive: "Deactivated",
    disabledAt: "Deactivated on",
    language: "Language",
    tutorial_enabled: "Enable interactive tutorials",
  },
  administration: {
    doc_commerciaux: "Documents",
    data_extract: "CSV exports",
    numerotations: "Numbering",
    validations: "MO / Specification validations",
    my_business: "My company",
    user_management: "User management",
    pass_management: "Permission management",
    add_user: "Add a user",
    devices: "JustUp live",
    advance: "Advanced settings",
    planning: "Default planning",
    ip: "IP security",
    identity: "Visual identity",
    infos: "Information",
    controles_generaux: "General controls",
    controles_generaux_chargement: "General loading controls",
    param_generaux: "General settings",
    validation: "General settings",
    custom_enum: "Enumerations",
    billing: "JustUp billing",
  },
  activity_infos: {
    logo: "Your company logo",
    color: "Your company color",
    delai_expedition_par_defaut: "Default shipping lead time (business days)",
    delai_expedition_par_defaut_placeholder: "e.g. 1",
    delai_expedition_par_defaut_hint:
      "Number of business days between shipping and customer delivery. Used to auto-compute the planned shipping date. Can be overridden per delivery address.",
    section_qualite_securite: "Quality & food safety",
    activer_blocage_dlc: "Block shipments containing an expired-DLC lot",
    activer_blocage_dlc_hint:
      "Recommended for fresh-food sites and IFS-compliant operators. A shipment containing a lot past its DLC will be refused (FR R. 412-21 Consumer Code). Only applies to articles classified as DLC; expired DDM only triggers a warning.",
  },
  validations: {
    specification: "Specification validation",
    of: "MO validation",
    facture: "Billing",
  },
  facture: {
    bulk_zip_btn: "Download PDFs",
    bulk_zip_tooltip:
      "Download a ZIP containing one PDF per selected invoice (file named by invoice / credit note number)",
    bulk_zip_select_first:
      "Select at least one invoice in the list (check the box on the left) to enable bulk download",
    bulk_zip_success: "{count} invoices downloaded in the ZIP",
    bulk_zip_error: "Bulk download failed. Please retry or check the logs.",
    transaction_type: "Payment type",
    transaction_amount: "Amount",
    transaction_add_cta: "Create a payment",
    transaction_edit_cta: "Edit a payment",
    transaction_link_to_facture: "Assign to another invoice",
    transaction_from_ps: "Payment automatically created from PrestaShop — read-only.",
    transaction_from_ps_tooltip: "Payment imported from PrestaShop",
    send_to_client: "Send to customer",
    generate_avoir: "Generate credit note",
    enter_tiers: "Enter the third party",
    attach_bl: "Attach a delivery note",
    no_bl_linked: "No delivery note linked",
    linked_avoir: "Linked credit note",
    linked_facture: "Linked invoice",
    payment: "Payment",
    add_payment: "Add a payment",
    imputer_avoir: "Apply a credit note",
    imputation_avoir_title: "Apply a customer credit note",
    imputation_avoir_help:
      "Pick a credit note from the same customer to apply against this invoice (settlement without cash).",
    imputation_avoir_select: "Available credit note",
    imputation_avoir_solde: "Credit note remaining balance",
    imputation_avoir_amount: "Amount to apply (€)",
    add_line: "Add a line",
    unit_price_ht: "Unit price excl. tax",
    billed: "Invoiced",
    unbilled: "Not invoiced",
    create: "Create invoice",
    add_cta: "Add an invoice/credit note",
    return_of: "Return of",
    to: "to",
    facturation: "Billing",
    add_ligne: "Add a line",
    not_billed: "Not invoiced",
    valid_facture: "Validate and lock the invoice",
    valid_avoir: "Validate and lock the credit note",
    valid_facture_warning:
      "You are about to assign a number to the invoice, this is irreversible. Do you confirm?",
    valid_avoir_warning:
      "You are about to assign a number to the credit note, this is irreversible. If customer returns are planned, they will be processed at the same time. Do you confirm?",
    en_cours: "In progress",
    a_regler: "To be paid",
    reglees: "Paid",
    en_attente_reglement: "Awaiting payment",
    echeance_depassee: "Overdue",
    echeances_depassees_detail: "Overdue invoices",
    echeances_voir_tout: "View #count other overdue invoice",
    echeances_voir_tout_plural: "View the #count other overdue invoices",
    echeances_dialog_title: "Overdue invoices",
    echeances_search_placeholder: "Search by number or third-party…",
    total_du: "Total due",
    tout_facture: "All invoiced",
    paiements_a_affecter: "Payments to assign",
    total_regle: "Total paid",
    transactions_list: "Payment list",
    etats_facture: "Invoice statuses",
    filter_amount_trigger: "Amount",
    filter_amount_mode_label: "Mode",
    filter_amount_min: "Min (€)",
    filter_amount_max: "Max (€)",
    filter_amount_clear: "Clear",
    filter_amount_active: "#mode: #min → #max",
    filter_amount_unbounded: "−",
    adresse_reintegration: "Return address",
    figer_numero: "Freeze and assign a number",
    paiement_dialog_title: "Assign a payment to an invoice",
    affectation: "Allocation",
    affectation_complete: "The payment amount is fully allocated",
    affectation_incomplete: "The payment amount is not fully allocated",
    affectation_exceeded: "The payment amount cannot be less than the sum of allocations",
    paiement_label: "#amount € paid on #date",
    paiement_label_plural: "#amount € paid on #date",
    bl_chooser_title: "Select delivery notes to associate",
    no_pending_bl_for_tiers: "No unbilled delivery note available for this third party",
    builder_create_facture: "Create an invoice",
    builder_edit_facture: "Edit an invoice",
    builder_create_avoir: "Create a credit note",
    builder_edit_avoir: "Edit a credit note",
    ref_document: "Document reference",
    ref_document_hint: "Free reference (e.g. reference provided by the customer)",
    ligne_builder_create: "Create an invoice line",
    ligne_builder_edit: "Edit an invoice line",
    ligne_type_commande: "Ordered",
    ligne_type_autre: "Other",
    mail_dialog_relance: "Send a payment reminder for the invoice",
    mail_dialog_send: "Send the invoice",
    mail_recipient: "Recipient",
    mail_cc: "CC",
    mail_message_placeholder: "Your message here...",
    mail_show_pdf: "View invoice",
    paiement_allocated: "#amount € allocated to #numero",
    paiement_allocated_plural: "#amount € allocated to #numero",
    total_paid: "Amount paid",
    remaining_due: "Remaining due",
    empty_lignes_draft: "Add your first invoice line",
    empty_lignes: "No lines",
    copied_numero: "Number copied",
    chrono_warning: "The date of this invoice (#date) is earlier than the last issued invoice #numero (#lastDate).",
  },
  chat: {
    label: "Chat",
    deactive: "Close",
    message_label: "Your message here ...",
    conversation_label: "Let's chat!",
    new_chat: "New conversation",
  },
  auth: {
    login: "Login",
    logout: "Logout",
    signup: "Create account",
  },
  home: {
    remote_operation: "Operation",
    remote_variable: "remote",
    remote_wait: "Please wait until it completes, or open a new tab!",
  },
  chatbot: {
    title: "Justy",
    tooltip: "Open assistant",
    placeholder: "Ask a question about Justup or your data...",
    welcome: "Hello! How can I help you?",
    welcome_named: "Hi #prenom! How can I help you?",
    import_commande_client: "Import a customer order",
    import_commande_client_hint: "Attach a purchase order (PDF or photo) and I'll handle the rest.",
    welcome_hint: "Ask me a question about using Justup or query your business data.",
    clear: "Clear conversation",
    new_conversation: "New conversation",
    no_conversations: "No conversations",
    delete: "Delete",
    send: "Send",
    toggle_sidebar: "Show/hide conversations",
    suggestion_of: "Latest WOs",
    suggestion_help: "Create a WO",
    suggestion_ca: "My revenue",
    attach_file: "Attach a document",
  },
  ribs: {
    isDefault: "Default bank details",
    setIsDefault: "Use as default",
    title: "Bank details",
    add_title: "Add bank details",
    edit_title: "Edit bank details",
    chose_title: "Choose payment bank details",
    add_cta: "Add bank details",
    empty: "No bank details registered",
    loading: "Loading...",
    unnamed: "Unnamed bank details",
    denomination: "Label",
    denomination_placeholder: "E.g.: Main account, Business account...",
    banque: "Bank code",
    banque_tooltip: "5 digits identifying the bank",
    guichet: "Branch code",
    guichet_tooltip: "5 digits identifying the branch",
    numero: "Account number",
    numero_tooltip: "11 alphanumeric characters",
    cle: "Key",
    cle_tooltip: "2 verification digits",
    IBAN: "IBAN",
    BIC: "BIC / SWIFT",
    BIC_hint: "Optional - Bank international code",

    show_details: "Show bank details",
    hide_details: "Hide bank details",
    rib_details: "Bank details (auto-filled from IBAN)",
    copy_iban: "Copy IBAN",

    form_invalid: "Please correct the form errors",

    validation: {
      iban_required: "IBAN is required",
      iban_format: "Invalid IBAN format",
      iban_key: "Invalid IBAN key",
      iban_length_fr: "French IBAN must contain 27 characters",
      bic_format: "Invalid BIC format (8 or 11 characters)",
      bank_code_format: "Bank code: 5 digits",
      branch_code_format: "Branch code: 5 digits",
      account_format: "Account number: 11 characters",
      rib_key_format: "RIB key: 2 digits",
    },
  },
  teams: {
    add_label: "Add a team",
    add_cta: "Add a team",
    edit_label: "Edit team",
    supervision: "Team supervision",
    supervision_team: "Team supervision",
    no_team: "You are not assigned to any team at the moment",
  },
  ocr: {
    start: "Start extraction",
    model_only: "Only create the specification",
    model_article: "Create an article and attach the template",
  },
  data: {
    articles_treated: "Articles processed",
    conso_delta: "Consumption variance",
    defineMax: "Define maximum possible",
    quantiteProduire: "Quantity to produce",
    quantiteAConsommer: "Quantity to consume",
    billing: "Billing",
    theoric_conso: "Theoretical consumption",
    manual_conso: "Declared consumption",
    consumed: "consumed",
    consumed_plural: "consumed",
    enregistrement: "record",
    enregistrements: "records",
    last_traced_lot: "Last traced lot",
    users: "Users",
    shipped: "Shipped:",
    ready_to_go: "On shipping units, awaiting shipment:",
    ordered: "Ordered:",
    client: "Customer",
    clients: "Customers",
    fournisseur: "Supplier",
    fournisseurs: "Suppliers",
    transporteur: "Carrier",
    details: "Details",
    dossier_prod: "Production file",
    dashboard: "Dashboard",
    confirmation: "Confirmation",
    facture: "Invoice",
    avoir: "Credit note",
    factures: "invoices",
    client_or_tiers: "Customer / Third party",
    bon_livraisons: "Delivery notes",
    designation: "Description",
    qty_ug_short: "Qty (MU)",
    tva_label: "VAT",
    totalTTC: "Total incl. tax",
    ttc_short: "Incl. tax",
    quantiteRetourClient: "Quantity to reintegrate",
    facture_avoir: "Invoices and credit notes",
    missing_info: "Missing information",
    validity_date: "Validity date",
    organisme: "Organization",
    certificat_bio: "Organic certificate",
    numero_certificat: "Certificate number",
    costs: "Costs",
    status: "Status",
    destinataire_mail: "Recipient",
    expediteur_mail: "Sender",
    denominationSpecif: "Specification name",
    denominationArticle: "Article name",
    stayConnected: "Do not force reconnection",
    showLots: "View end-of-line lots",
    modifyControleUserDate: "Modify controller and control date",
    link: "Link",
    instructionsAI: "AI instructions",
    consigneNC: "Instructions in case of non-compliance",
    tolerance: "Tolerance",
    login: "Username",
    controle_conso: "How much remains in WIP of lot",
    bilan_matiere: "Material balance",
    billings: "JustUp billing",
    delaiReglementJour: "Payment term (days)",
    ip: "IP",
    devise: "Currency",
    checklists: "Checklists",
    documents: "Documents",
    ribs: "Bank details",
    models: "Article templates",
    prixUnitaireAchat: "Unit price (per purchase unit)",
    stats: "Statistics",
    quantitePrevue: "Expected quantity",
    dechargements: "Unloadings",
    receptions: "Receptions",
    controleParQuantite: "Sample depending on the quantity to control",
    echantillonParQuantite: "Quantity per sample (in management unit)",
    quantite_recue: "Quantity received",
    conforme: "Compliant",
    non_conforme: "Non-compliant",
    quantite_conforme: "Compliant",
    quantite_non_conforme: "Non-compliant",
    sscc: "SSCC / shipping unit number",
    general_controls: "General controls",
    textColor: "White initials",
    prixParDefaut: "Default price",
    prixUnitaire: "Unit price",
    mailDefault: "Primary email",
    mailPrecision: "Email details",
    mailPrecision1: "Specific emails by send type (optional)",
    mailPrecision2: "If not provided, the primary email will be used.",
    mailCommande: "Orders sent to supplier",
    mailCommandeClient: "Orders placed by customer",
    mailFacturation: "Customer invoices",
    coutMaterielUnitaire: "Unit material cost",
    coutPersonnelUnitaire: "Unit labor cost",
    desc_commerciale: "Commercial description",
    microbio: "Microbiological criteria",
    diametre: "Diameter",
    densite: "Density (kg/L)",
    coefficientUnite: "Coefficient",
    device: "JustUp Live device",
    not_applicable: "Not applicable",
    applicable: "Applicable",
    bilanMatiere: "Material balance",
    chargements: "Shipment preparation",
    quantiteAchat: "Quantity in purchase unit",
    quantiteGestion: "Quantity in management unit",
    uniteClient: "Sales unit",
    uniteFournisseur: "Purchase unit",
    uniteGestion: "Management unit",
    quantiteIn: "Quantity in",
    quantiteTotaleIntegree: "Total quantity integrated",
    dates: "Dates",
    teams: "Teams",
    team: "Team",
    horaires: "Hours",
    declared_in_prod_plural: "Declared in production",
    declared_in_prod: "Declared in production",
    scoreMatiere: "Raw material performance",
    scorePersonnel: "Labor performance",
    scoreTotal: "Total economic performance",
    param_mail: "Email settings",
    signature_placeholder: "Your signature here...",
    born_on: "born on",
    entrepot_par_defaut: "Default warehouse",
    profile_page: "Profile page",
    lotExpedie: "Shipped quantity",
    codeGS1: "GS1 company code",
    sans_identifiant: "No identifier",
    poste_annule: "Delete production operation",
    MAIL_HOST: "SMTP host",
    MAIL_USER: "Username",
    MAIL_PASSWORD: "Password",
    MAIL_FROM: "Default sender address",
    subject: "Subject",
    startAdresse: "Origin address",
    endAdresse: "Destination address",
    user: "User",
    delivery_adresse: "Delivery address",
    received_by_singular: "Received by the following order",
    received_by_plural: "Received by the following orders",
    produced_by_singular: "Produced by the following MO",
    produced_by_plural: "Produced by the following MOs",
    receiveConfirmationCommandeClientMail:
      "Is copied on customer order confirmation emails",
    receiveCommandeMail: "Is copied on supplier order emails",
    receivePosteMail: "Is copied on end of shift emails",
    receiveBilanMatiereMail: "Is copied on material balance emails",
    postes: "Production operations",
    isPhoto: "Photo recording",
    isValeur: "Value recording",
    type_fiche: "Printable sheet format",
    quantiteRefuse: "Rejected quantity",
    unite_simple: "Unit",
    stocks: "View stocks",
    lots: "View stocks",
    info_generales: "General info",
    dureePoste: "Operation duration (h)",
    valeurUnitairePonderee: "Unit value (latest known cost)",
    quantiteTotale: "Total quantity",
    compteur: "Counter",
    etat: "State",
    valeur: "Value",
    nb_articles: "Number of articles",
    nb_lots: "Number of lots",
    to_compte: "Count in this area",
    comptage: "Counts in this area",
    compteRetenu: "Retained count",
    zone: "Area",
    valeurTotale: "Total value",
    compte: "Count",
    comptages: "Counts",
    valeurUnitaire: "Default unit value",
    valeurUnitaireInventaire: "Unit value",
    complets: "Number of full packages",
    complets_rouleaux: "Number of full rolls",
    inventaire: "Inventory",
    inventaires: "Inventories",
    objectif_nominal: "Record average",
    evenement: "Event",
    bonLivraison: "Delivery note",
    bonsLivraison: "Delivery note",
    commentaire: "Comment",
    prefixArticleRef: "Article reference prefix",
    prefixLot: "Lot number prefix",
    prefixCommande: "Supplier order number prefix",
    prefixFactureCommandeClient: "Customer invoice number prefix",
    prefixAvoirClient: "Customer credit note number prefix",
    prefixOf: "MO number prefix",
    prefixBonLivraison: "Customer delivery note number prefix",
    prefixBonRetour: "Supplier return note number prefix",
    prefixCommandeClient: "Customer order number prefix",
    prefixDechargement: "Unloading number prefix",
    prefixReception: "Reception number prefix",
    autres_travaux: "Other work",
    graphs: "Charts",
    titre: "Title",
    resume: "Description",
    type_retour: "Feedback type",
    pcb: "PCB",
    codeClient: "Customer code",
    provisoire: "Provisional",
    stockDispo: "Available stock",
    stockReappro: "Reorder stock",
    stockSecurite: "Safety stock",
    quantiteOfDefault: "Default manufacturing quantity",
    quantiteAchatDefault: "Default purchase quantity",
    stockParams: "Stock parameters",
    stockInfos: "Stock info",
    stockInfosSubtitle: "Reorder and safety thresholds",
    commandeInfos: "Order info",
    commandeInfosSubtitle: "Default parameters for purchase orders",
    proprietaire: "Owner",
    ingredients: "Ingredients list (write allergens in CAPITALS)",
    allergenes: "Allergens list",
    nombreFicheToPrint: "Number of sheets to print",
    lots_infos: "Lot information",
    ean13: "EAN 13",
    ean14: "EAN 14",
    ean14prefix: "EAN 14 prefix",
    ean128: "EAN 128",
    isDone: "Completed / taken into account",
    gross_weight: "Gross weight",
    gross_weight_uc: "Gross weight CU(kg)",
    net_weight_uc: "Net weight CU(kg)",
    longueur_uc: "Length CU(cm)",
    hauteur_uc: "Height CU(cm)",
    largeur_uc: "Width CU(cm)",
    gross_weight_colis: "Gross weight package(kg)",
    net_weight_colis: "Net weight package(kg)",
    longueur_colis: "Length package(cm)",
    hauteur_colis: "Height package(cm)",
    largeur_colis: "Width package(cm)",
    calculBesoin: "Requirements calculation",
    quantiteDispo: "Available quantity (excluding WIP)",
    version: "Version",
    specification: "Specification",
    total: "Total",
    totalHT: "Total excl. tax",
    dateEcheance: "Due date",
    transactions: "transactions",
    avecRetour: "With product return",
    returnOf: "Return of",
    at: "to",
    on: "on",
    numeroBL: "Delivery note number",
    reduction: "Discount",
    restant: "Remaining quantity",
    compensation: "Compensation",
    avecReintegration: "Stock reintegration",
    avoir_make: "Credit note management",
    avoirs: "Order credit notes",
    ca: "Revenue",
    prixCommande: "Agreed price",
    prixDeVente: "Invoiced price",
    facturation: "Billing",
    fj: "Legal form",
    capital: "Capital (€)",
    rcsVille: "RCS (City)",
    rcsNumero: "RCS (Number)",
    codeAPE: "APE code",
    tvaIntracom: "Intra-community VAT",
    email: "Email",
    emailFacture: "Invoice recipients",
    telephone: "Phone",
    telephone2: "Phone 2",
    adresse: "Address",
    adresses: "Addresses",
    rib: "Bank details",
    infoBLClient: "Information to appear on customer order delivery notes",
    infoConfirmationCommandeClient:
      "Information to appear on customer order confirmations",
    infoRetourFournisseur: "Information to appear on supplier returns",
    infoBlClient: "Information to appear on customer delivery notes",
    infoCommandeFournisseur: "Information to appear on supplier orders",
    infoFactureExpedition: "Information to appear on customer invoices",
    infoAvoirClient: "Information to appear on customer credit notes",
    quantiteAReintegrer: "Quantity to reintegrate to stock",
    integrateInStock: "Integrate to stock",
    enExpe: "On the shipping unit",
    qttTotalCommande: "Ordered quantity",
    infosprix: "Commercial info",
    sousFamille: "Technical family",
    correctAnswer: "Correct answer",
    typePeriode: "BBD type",
    dluoJours: "BBD (Days)",
    dluoMois: "BBD (Months)",
    dluoAnnes: "BBD (Years)",
    historique: "History",
    schema: "Schema",
    nb_schema: "Tolerance",
    mode: "Operating mode",
    coutTotalReel: "Total cost",
    coutUnitaireReel: "Cost per unit produced",
    coutHoraireReel: "Average hourly cost",
    coutTotalTheorique: "Total cost",
    coutUnitaireTheorique: "Cost per unit produced",
    surcoutTotal: "Total overcost (€)",
    surcoutUnitaire: "Unit overcost (€)",
    surcoutUnitairePourcent: "Unit overcost (%)",
    theorique: "Theoretical",
    isEcart: "Variance calculation",
    valeur1: "First value",
    valeur2: "Second value",
    reel: "Actual",
    analyse: "Analysis",
    operator: "Operator",
    heures_saisies: "Recorded hours",
    heuresLigne: "Line hours",
    heuresTheorique: "Theoretical duration",
    heuresTravailles: "Paid hours",
    heureAffectees: "Assigned hours",
    heuresFormation: "Training hours",
    ecartHeuresTravailles: "Hours variance",
    coutTotalPersonnel: "Total labor cost",
    ecartCoutTheorique: "Theoretical cost variance",
    ecartCoutTheoriquePourcent: "Theoretical cost variance (%)",
    productiviteTheorique: "Theoretical productivity (u/h)",
    productiviteReel: "Actual productivity (u/h)",
    productivitePourcent: "Productivity performance (%)",
    ecart: "Variance",
    coutUnitaire: "Unit cost",
    coutTheorique: "Total theoretical cost",
    coutReel: "Total actual cost",
    format: "Format",
    productivite: "Productivity",
    heures: "Hours",
    coutTotal: "Total cost",
    coutHoraire: "Hourly cost",
    mouvements: "Movements",
    controlesLiberatoires: "Release controls",
    quantiteUnitaire: "Unit quantity",
    lotsPdc: "Starting lot",
    tracabilite: "Traceability",
    nouveauLot: "New lot",
    poste_when: "Production op. of ",
    dateChangement: "Change date",
    changement_lot: "Traceability and Consumptions",
    quantiteProduite2: "Quantity produced",
    quantiteProduite: "Number of finished products on the line",
    quantiteProduiteTotal: "Remaining quantity to integrate",
    produitsSurLigne: "Products on line",
    consoTheoriqueUnitaire: "Theoretical unit consumption",
    consoTheorique: "Theoretical consumption",
    consoTheoriqueTotalOf: "Total theoretical consumption MO",
    retourPdc: "WIP return",
    piedDeChaine: "Work-in-process",
    consoProd: "Prod. consumption",
    pertes: "Losses",
    pertesPourcent: "Losses (%)",
    lot: "Lot",
    misEnPdc: "Placed in WIP",
    emplacement: "Location",
    identifiantObligatoire: "Mandatory identifier",
    commentairePositif: "Positive comment",
    commentaireNegatif: "Negative comment",
    derniereUniteProduite: "Last unit produced",
    identifiant: "Identifier",
    saisie: "Entry",
    linkedFacture: "Linked invoice",
    linkedAvoir: "Linked credit note",
    productions: "Productions",
    cadence: "Nominal rate (/h)",
    nbPersonnes: "Number of workers",
    bilanProductivite: "Productivity report",
    tempsCalage: "Setup time (minutes)",
    tempsNettoyage: "Cleaning time (minutes)",
    denomination: "Name",
    profile: "My profile",
    infos: "Info",
    colors: "Colors",
    minutes: "Minutes",
    nomenclature: "Bill of materials",
    stock: "Stock",
    detail_stock: "Stocks and lots",
    of: "MO",
    of_title: "Manufacturing Orders (MO)",
    naf: "NAF",
    dateDebut: "Effective date",
    dateStart: "Start date",
    startedAt: "Started on",
    fromDate: "from",
    toDate: "to",
    dateEnd: "End date",
    tva_intracom: "Intra-community VAT",
    planning: "Planning",
    majorationPercent: "Salary increase (%)",
    majorationSalaire: "Salary increase (€)",
    panier: "Meal allowance (€)",
    detail_lot: "Lot details",
    personnel: "Personnel",
    tauxHoraire: "Hourly rate (All included)",
    dluo: "Expiry date",
    quantite: "Quantity",
    quantiteAProduire: "Quantity to produce",
    quantiteUniteGestion: "Quantity (management unit)",
    siret: "SIRET",
    numero: "Number",
    tva: "VAT (%)",
    actions: "Actions",
    mouvement: "Movement",
    date_mouvement: "Movement date",
    dateCreation: "Placement date",
    tailleEchantillon: "Sample size",
    nombreEnregistrement: "Minimum number of records",
    choix: "Available choices",
    dateReception: "Reception date",
    dateLivraison: "Expected delivery date",
    lotFournisseur: "Supplier lot number",
    quantiteReception: "Received quantity",
    dateValidation: "Validation date",
    dateConfirmation: "Confirmation date",
    dateFermeture: "Closing date",
    type_mouvement: "Movement type",
    francoPrix: "Free delivery (Price)",
    francoQuantite: "Free delivery information",
    code: "Article code",
    commandes: "Supplier orders",
    commandes_client: "Customer orders",
    commande_client: "Customer order",
    famille: "Family",
    debut: "Start",
    fin: "End",

    numeroCommandeClient: "Customer order number",

    quantiteAUtiliser: "Quantity to use",
    quantiteARajouterPalette: "Quantity to add to shipping unit",
    quantiteReintegrer: "Quantity to reintegrate",

    heuresTravaillees: "Worked hours",
    heuresRTT: "RTT hours",
    heuresConges: "Leave hours",
    heuresMaladie: "Sick leave hours",
    heuresNonJustifiees: "Unjustified hours",

    sous_famille: "Technical family",
    delaiReglement: "Payment term",
    typeReglement: "Payment type",
    unite: "Management unit",
    unite_achat: "Purchase unit",
    unite_vente: "Sales unit",
    unite_base: "unit",
    reference: "Reference",
    reference_fournisseur: "Supplier ref.",
    reference_client: "Customer ref.",
    coefficientUniteGestion: "Management unit coef.",
    multipleAchat: "Purchase multiple",
    multipleVente: "Sale multiple",
    multiple_placeholder: "e.g. 2045",
    poste: "Shift",
    role: "Role",
    modele: "Use a template",
    quantiteMin: "Min qty",
    quantiteMax: "Max qty",
    prix: "Price",
    prixTTC: "Price incl. tax",
    delaiLivraison: "Delivery lead time (business days)",
    ligne: "Prod. line",
    lignes: "Prod. lines",
    type: "Type",
    type_list: "List type",
    tiers: "Customers and suppliers",
    current: "Current",
    changePassword: "Change password",
    password: "Password",
    confirmPassword: "Confirm password",
    passwordMismatch: "Passwords do not match",

    articles: "Articles",
    article: "Article",
    duree: "Duration",
    administration: "Administration",
    infos_perso: "Personal info",
    colorization: "Colors",
    label: "Label",
    description: "Description",
    description_variable: "Parameter description",
    settings: "Settings",
    informations_generales: "General information",
    composants: "Components",
    procede_article: "Article process",
    procede: "Process",
    controls: "Controls",
    nom: "Last name",
    prenom: "First name",
    ddn: "Date of birth",
    sexe: "Gender",
    date: "Date",
    qte: "Qty",

    modeOperatoire: "Operating procedure",

    limiteHaute: "Upper limit",
    limiteBasse: "Lower limit",
    nominal: "Nominal",

    limiteHauteString: "Upper limit",
    limiteBasseString: "Lower limit",
    nominalString: "Nominal",
    delivery_adress: "Delivery address",
    billing_adress: "Billing address",
    entrepot_depart: "Departure warehouse",
    entrepot_stockage: "Storage warehouse",
    quantityProdDefault: "Reference quantity",
    quantityProdDialogTitle: "Reference quantity modification",
    transfert: "Transfer",
    commande: "Order",
    dechargement: "Unloading",
    reception: "Reception",
    palettes: "Shipping units",
    livraisons: "Deliveries",
    contacts: "Contacts",
    commercial: "Sales",
    procedes: "Processes",
    params_specification: "Specification parameters",
    logistique: "Logistics",
  },
  models: {
    add_cta: "Add a template",
    articles_linked: "Linked articles",
    no_articles_linked: "No linked articles",
    articles_linked_dialog_title: "Articles linked to the specification",
  },
  onboarding: {
    page_title: "Onboarding",
    page_subtitle: "Set up and get to grips with JustUp, step by step.",
    sidenav_label: "Onboarding",
    guides: "guides",
    status_not_started: "To start",
    status_in_progress: "In progress",
    status_learned: "Learned",
    status_done: "Configured",
    status_complete: "Complete",
    action_start_guide: "Start the guide",
    action_watch_video: "Watch the video",
    action_ask_justy: "Ask Justy",
    data_check_ok: "Data present",
    data_check_missing: "No data yet",
    refresh_checks: "Check",
    next_step: "Next step",
    welcome_title: "Welcome to JustUp!",
    welcome_subtitle: "Set up and learn JustUp by following your onboarding path.",
    welcome_description: "The path guides you group by group, combining interactive tutorials with entering your first real data.",
    welcome_start: "Start onboarding",
    welcome_later: "Later",
    justy_prompt_module: "How do I: #module? Explain it simply, step by step.",
    justy_prompt_general: "Help me get started with JustUp: where do I begin?",
    trophies_title: "Your trophies",
    parcours_title: "Your journey",
    recommended: "Recommended",
    cta_start: "Get started",
    cta_resume: "Resume",
    level: "Level #n",
    xp: "#n XP",
    xp_to_next: "#n XP to next level",
    quickwin_goal: "Goal",
    quickwin_reached: "Unlocked!",
    concepts_ack: "I understand the logic",
    concepts_acked: "Logic understood",
    phases: {
      comprendre: { title: "Understand JustUp", verb: "Understand", subtitle: "5 min to grasp the data logic before configuring." },
      demarrage: { title: "Get your bearings", verb: "Navigate", subtitle: "Discover the interface, the menu and your daily tasks." },
      entreprise: { title: "Set up your company", verb: "Configure", subtitle: "Company, activity and production lines." },
      catalogue: { title: "Build your catalog", verb: "Build", subtitle: "Articles, specifications, bills of materials and quality controls." },
      approvisionnement: { title: "Source your materials", verb: "Purchase", subtitle: "Suppliers, purchase orders and goods receipts." },
      fabrication: { title: "Manufacture", verb: "Produce", subtitle: "Manufacturing orders, planning and traceability." },
      vente: { title: "Sell & ship", verb: "Sell", subtitle: "Customer orders, shipments, delivery notes and invoices." },
      pilotage: { title: "Steer your business", verb: "Steer", subtitle: "Stock, traceability, dashboards and profitability." },
    },
    quickwins: {
      logique: { title: "Logic understood", desc: "You've understood how JustUp structures your data." },
      navigation: { title: "Navigation mastered", desc: "You know how to find your way around JustUp." },
      usine: { title: "Factory set up", desc: "Your company and production lines now exist in JustUp." },
      produit: { title: "First manufacturable product", desc: "An article and its specification are ready to be produced." },
      matiere: { title: "First materials received", desc: "A supplier, a purchase order: your first materials enter stock." },
      of: { title: "First production order", desc: "You've created your first manufacturing order." },
      facture: { title: "First sale invoiced", desc: "A customer order turned into an invoice." },
      autonome: { title: "Autonomous operator", desc: "You master the whole cycle: you run JustUp on your own." },
    },
    justy: {
      welcome: "Welcome to JustUp! I'm Justy, here to help. Let's start with #phase. 🚀",
      progress: "Great work! Recommended next step: #phase. 💪",
      near_done: "You're almost there — one more push and you'll be fully autonomous! 🏆",
      done: "Well done, your onboarding is complete. You're 100% autonomous on JustUp! 🎉",
    },
    celebration: {
      quickwin: "Trophy unlocked!",
      levelup: "Level reached!",
    },
    concepts_title: "Understand JustUp before configuring",
    concepts_subtitle: "Before entering your data, take 5 minutes to understand how JustUp structures information.",
    logic_title: "The data logic",
    glossary_title: "Glossary",
    of_cycle: {
      title: "The production cycle",
      s1_t: "Article + Line", s1_c: "nomenclature & process · technical family",
      s2_t: "Manufacturing order", s2_c: "make the article on the line · ± input stock",
      s3_t: "Production", s3_c: "record controls + traceability",
      s4_t: "Reintegration", s4_c: "the produced quantity enters stock (finished product)",
      s5_t: "Performance analysis", s5_c: "yield, real costs and MO variances",
    },
    schema: {
      model: "Spec model",
      model_sub: "recipe + process + controls + variables",
      inherit: "inherits",
      article_own: "+ own values",
      supplier: "Supplier",
      client: "Customer",
      buy_price: "purchase price",
      sell_price: "sale price",
      component_cost: "Component cost",
      nomenclature: "via nomenclature",
      finished_cost: "Finished product cost",
      margin: "Margin",
      schema_model_caption: "One model, as many articles as variants.",
      schema_cascade_caption: "Cost flows up the recipe; compared to the sale price, it gives the margin.",
      schema_spec_caption: "A specification = nomenclature + process + controls, parameterized by variables.",
      nomenc_proc: "nomenclature + process",
      param_ligne: "settings · technical family",
      of_fabricate: "make the article on the line",
      of_stock_in: "± input stock",
      prod_saisie: "entry: controls + traceability",
      reintegration: "Reintegration",
      perf: "Performance analysis",
      pf_stock: "Finished product → stock",
      production: "Production",
      ligne: "Production line",
      schema_of_caption: "The production cycle: article + line → MO → production → reintegration (stock + analysis).",
    },
    logic: {
      modele_to_article: { title: "Spec models → articles", body: "First you create spec MODELS (recipe + process + controls) with VARIABLES for what changes. Each manufactured article links to one and fills in its variables: one model, as many articles as variants." },
      familles: { title: "Families & sub-families", body: "Each article is classified by family (and sub-family): this is the commercial organization, used for stats, analyses and groupings." },
      famille_technique: { title: "Technical family & line", body: "A manufactured article must have a technical family: it links it to a production line. Without it, you can't plan or launch a manufacturing order." },
      lignes: { title: "Production lines", body: "Lines represent your manufacturing tools. Technical families attach to them so you know where and how each product is made." },
      tiers_fournis: { title: "Partners & supplied articles", body: "Suppliers and customers are partners. For each article × partner pair, a 'supplied article' carries the price, unit and reference specific to that partner (purchase on the supplier side, sale on the customer side)." },
      cascade_prix: { title: "Price info cascade", body: "Purchase prices (supplier supplied-articles) give the component cost; this cost flows up the nomenclature to the finished product, then is compared to the sale price (customer supplied-articles) to compute the margin. Everything updates in cascade." },
    },
    glossary: {
      article: { term: "Article", def: "A reference managed in JustUp: raw material, packaging, or manufactured/sold product." },
      specification: { term: "Specification", def: "The full technical sheet of a manufactured product: recipe, process and controls, versioned." },
      modele_specif: { term: "Spec model", def: "A shared, reusable specification: several articles link to it instead of redoing everything." },
      variable: { term: "Variable", def: "A model parameter that changes per article (e.g. sugar rate). Each article sets its value." },
      nomenclature: { term: "Nomenclature", def: "The recipe: list of components and quantities to make the product." },
      procede: { term: "Process", def: "The manufacturing steps (mixing, baking, packaging…), some optional." },
      controle: { term: "Control", def: "A quality control point (conforming/non-conforming, measurement, CCP…) attached to a step." },
      famille: { term: "Family", def: "The main commercial classification of an article (e.g. Jams, Sauces)." },
      sous_famille: { term: "Sub-family", def: "A subdivision of the family to refine the classification." },
      famille_technique: { term: "Technical family", def: "The production grouping of a manufactured article, linked to a line — required to produce." },
      ligne: { term: "Production line", def: "The tool/station where you manufacture. Linked to technical families." },
      tiers: { term: "Partner", def: "A partner: supplier or customer." },
      article_fourni: { term: "Supplied article", def: "The article × partner link: negotiated price, unit and reference for that partner (purchase or sale)." },
      infos_prix: { term: "Price info", def: "The price tiers of a supplied article (price by quantity). They feed the cost/margin cascade." },
      lot: { term: "Lot", def: "A traced physical batch of product (reception or production), with use-by dates." },
      of: { term: "Manufacturing order (MO)", def: "Launching the production of an article in a quantity, on a line." },
    },
  },
  routing: {
    onboarding: "Onboarding",
    back: "Back",
    auth: "Authentication",
    justup_link: "JustUp Link",
    justup_link_qr: "JustUp Link Qr",
    administration: "Administration",
    entreprise: "Company",
    stats: "Stats.",
    facturation: "Billing",
    gestion_equipes: "Team management",
    tracabilite: "Traceability",
    analyse_ca: "Revenue analysis",
    checklists: "Checklists",
    expeditions: "Shipments",
    factures: "Invoices",
    inventaire: "Inventory",
    specification: "Specification",
    parametrage_admin: "Admin settings",
    pied_de_chaine: "Line-side stock",
    articles: "Articles",
    production: "Production",
    commandes: "Orders",
    transferts_entrepot: "Warehouse transfers",
    commandes_clients: "Customer orders",
    lot: "Batch",
    lignes_prod: "Prod. lines",
    saisie_heures: "Time entry",
    planif_ofs: "WO planning",
    planif_articles: "Article planning",
    gestion_tiers: "Third party management",
    parametrage_activite: "Activity settings",
    stocks: "Stock",
    profil: "Profile",
    connexion_ecommerce: "E-commerce connection",
    synchronisation_ecommerce: "E-commerce sync",
    ofs: "Work orders",
    suivi_production: "Production monitoring",
    suivi_fabrication: "Manufacturing monitoring",
    suivi_prod: "Prod. monitoring",
    ope_fab: "Manuf. operation",
    bilan_matiere: "Material balance",
    mouvements: "Movements",
    statistiques: "Statistics",
    heures_saisies: "Logged hours",
    infos_generales: "General info",
    logistique: "Logistics",
    nomenclature: "Bill of materials",
    procede: "Process",
    controles_article: "Article controls",
    specification_article: "Article specification",
    parametres_specification: "Specification parameters",
    commercial: "Commercial",
    article_infos: "Article info",
    specifications_produit: "Product specifications",
    commande: "Order",
    dechargement: "Unloading",
    reception: "Reception",
    dechargements: "Unloadings",
    commande_client: "Customer order",
    palettes: "Shipping units",
    livraisons: "Deliveries",
    lot_infos: "Batch info",
    couts: "Costs",
    transfert_entrepot: "Warehouse transfer",
    reception_transfert: "Transfer reception",
    comptage: "Counting",
    mon_entreprise: "My company",
    exports_csv: "CSV exports",
    adresses: "Addresses",
    documents: "Documents",
    numerotations: "Numbering",
    parametres_avances: "Advanced settings",
    facturation_justup: "JustUp billing",
    tiers: "Third parties",
    groupes: "Groups",
    groupe: "Group",
    infos_generales_tiers: "General info",
    contacts: "Contacts",
    rib: "Bank details",
    infos_perso: "Personal info",
    horaires: "Schedule",
    parametrage_mail: "Mail settings",
    gestion_utilisateurs: "User management",
    gestion_autorisations: "Authorization management",
    planning_defaut: "Default planning",
    enumerations: "Enumerations",
    controles_generaux: "General controls",
    parametrages_generaux: "General settings",
    unites_expedition: "Shipping units",
    pdc: "LSS",
    reintegration_pdc: "LSS reintegration",
    stock: "Stock",
    stats_of: "WO stats",
  },
  fiche_palette: {
    add: "Add a sheet template",
  },
  tooltip: {
    go_commande: "View order",
    view_detail: "View details",
  },
  bl: {
    add_label: "Prepare a new shipment",
    add_palette_label: "Add a shipping unit",
    no_linked_bl: "No linked delivery note",
    link_bl: "Attach a delivery note",
    waiting_billing: "Delivery note awaiting billing",
    multiple_waiting_billing: "Delivery notes awaiting billing",
    scan_already_scanned: "You have already scanned this shipping unit",
    scan_palette_ready: "Shipping unit ready for shipment",
  },
  changement_lot: {
    cta: "Enter traceability",
    orphan_tooltip:
      "Lot attached by inference (entered outside any active operation). Verify which operation it belongs to.",
    label: "Traceability entry",
    label_conso: "Traceability and consumption entry",
    used_from: "used from",
    take_from_pdc: "Take from MO component stock (WIP)",
    take_from_stock: "Take from general stock (warehouse:",
    label_poste: "Operation on which this traceability entry takes place",
    quantite_consommation: "Enter a consumed quantity",
    quantite_consomme: "Consumed quantity",
    already_declared_consommation: "Already declared consumption",
    declared_consommation: "Declared consumption",
    total_pdc: "Total in WIP",
    reste_disponible: "Available quantity in WIP",
    is_traca_obligatoire_missing_message_part1: "Article",
    is_traca_obligatoire_missing_message_part2:
      "has no traceability record. Add one to continue.",
    is_traca_obligatoire_missing_header:
      "Traceability missing for the following articles:",
    is_traca_obligatoire_missing_item: "traceability missing",
    missing: "To be completed",
    why_cannot_no_ope:
      "To enter traceability, please start a production operation first",
  },
  controles: {
    frequence_limit: "(tolerance cannot exceed half the frequency)",
    isCCP: "is a CCP (Critical Control Point)",
    isPRPO: "is an oPRP (Operational Prerequisite Programme)",
    isCalage: "Setup control",
    isJustupTodo: "Appears in task lists linked to the MO",
    isProd: "Production control",
    isFinPoste: "End of shift control",
    isFinProd: "End of production control",
    add_evenement: "Add an event",
    add_cta: "Add a control",
    add_choice: "Add a choice",
    add_enregistrement: "Add a record",
    correct_answer: "Correct answer",
    select_answer: "Click on the correct answer",
    reception: "Reception controls",
    reception_lot: "Lot reception controls",
    ecartMinutes: "Variance (minutes)",
    toleranceMinutes: "Tolerance (minutes)",
    poste_start: "Start production operation",
    poste_end: "End production operation",
    start_rattrapage: "Catch up hours",
    stop_rattrapage: "Stop catch-up",
    with_courbe: "With curve display",
    with_dynamic: "With dynamic values",
    infos: "General info",
    param_saisies: "Entry parameters",
    configuration: "Configuration",
    quand: "When?",
    quelles_lignes: "Line(s) to exclude",
    aucune_donnee: "No data available for this control",
    ajouter_reponse: "Add a response...",
    familles_categories: "Families / Categories",
    ajouter_evenement: "Add an event...",
    controles_generaux: "General controls",
    saisir: "Enter the control",
    conforme: "Compliant",
    non_conforme: "Non-compliant",
    a_faire: "To do",
    realiser_controle: "Perform the control",
    non_realise: "Not performed",
    valeur_placeholder: "Value",
    commentaire_placeholder: "Comment...",
    ajouter_evenement_placeholder: "Add an event...",
    tips_form_timing:
      "You can define when and how the control should be performed:\n" +
      "\n" +
      "Regular frequency control: set an interval and a tolerance (e.g.: every 10 min ± 3 min).\n" +
      "\n" +
      "Event: create one or more events (e.g.: label roll change) that will manually trigger the control when they occur.\n" +
      "\n" +
      "Both options can be used together or separately.\n" +
      "If you don't check any box, the control will be performed only once.",
  },
  lot: {
    edit: "Lot modification",
    actions: "Lot actions",
    page: "Lot page",
    goToOf: "Production order",
    goToCommande: "Supplier order",
    create: "Create a lot",
    search: "Lot number...",
    createAndSelect: "Create a new lot",
    unique: "Single lot",
    emptyCantCreate: "To select a lot, please add it to the WIP first",
    select: "Select a lot",
    count: "Count",
    transferer: "Transfer",
    quick_transfer_title: "Quick transfer",
    quantite_a_transferer: "Quantity to transfer",
    adresse_destination: "Destination warehouse",
    adresse_depart: "Origin address",
    fusionner: "Merge lots",
    stock_cumule_label: "Cumulative stock evolution",
    stock_cumule_empty:
      "Select one or more lots to display the cumulative stock evolution.",
    no_stock: "No stock available for this lot based on criteria.",
    recalculer: "Recalculate quantity",
    depart_mouvement: "Movement origin",
    arrivee_mouvement: "Movement destination",
    quantite_mouvement: "Movement quantity",
    lots_sans_stocks: "Lots without stock",
    lot_not_in_pdc: "This lot is not present in WIP",
    type_mouvement_filter: "Movement type",
    date_filter: "Date",
    adresse_filter: "Address",
    comptage_title: "Counting",
    methode_prefix: "Method:",
    compter_packs: "Count the number of packs containing",
    controles_liberatoires: "Release controls",
  },
  commande: {
    ligneEdit: "Order line editing",
    commandeEdit: "Modify order",
    dateManuelle: "Force a delivery date",
    ligneCreate: "Add an order line",
    missing_delivery_date: "Please enter the expected delivery date",
    consulter_tiers: "View supplier/customer",
    dechargement: "Unloading",
    desannuler: "Uncancel",
    fiche_palette: "Shipping unit sheet",
    ajouter_lot: "Add a lot",
    qte_superieure_zero: "Received quantity must be greater than 0",
    conformite: "Compliance",
    etats_commande: "Order status",
    facturer: "Invoice",
    ajouter_article_vendu: "Add a sold article",
    prix_libre: "Free price",
    adresse_livraison: "Delivery address:",
    adresse_facturation: "Billing address:",
    numero: "Number",
    voir_bon_commande: "View purchase order",
  },
  production: {
    voir_qte_par_poste: "View quantities per workstation",
    matiere: "Material",
    retour_liste: "Back to list",
    cancelReinte: "Cancel reintegration",
    cancelReinteWarning: "Do you really want to cancel the WIP reintegration?",
    preparePDC: "Prepare WIP",
    reintePDC: "Reintegrate WIP",
    integrationPF: "Early integration",
    canBeMoreProduit: "May be higher because production is in progress",
    dashboard_report: "Machine dashboard",
    chose_ope_cta: "Select an operation:",
    chose_ope_cta_big: "Please select an operation to view",
    create_ope_cta_big: "No operation has been created on this MO yet",
    fill_bilan: "Enter material balance",
    consult_bilan: "View material balance",
    select_ligne: "Select a line",
    select_of: "Select a MO",
    start: "Start production",
    startNow: "Start now",
    continue: "Continue production",
    startNextOpe: "Start next operation",
    plan: "Plan the MO",
    add_poste: "New production operation",
    end_poste: "End production operation",
    add_prod: "Add a production",
    end_prod: "End production",
    go_attente_reinte: "Awaiting WIP return",
    poste_starting: "Production operation starting",
    pdc_retour: "WIP reintegration",
    pdc: "Work-in-process",
    restart_prod: "Restart production",
    preview_poste: "Startup info preview",
    please_start_ope: "Please start the operation",
    close_without_prod: "Close operation without production",
    add_hours: "Add labor hours",
    ope_quantity_cta:
      "To perform certain calculations during the process, the specification requires the expected quantity.",
    ope_dialog: "New operation",
    create_first_ope: "Create the first production operation",
    validation_of: "MO validation",
    validate_qualite: "Validate the MO from a quality perspective",
    validate_prod: "Validate the MO from a production perspective",
    validate: "Validate the MO",
    finOpe: {
      title: "Quantity produced",
      integre_cette_ope: "Already integrated on this operation",
      integrations_note:
        "These #qte #unite are already included in the calculation.",
      locked_title: "Entry locked",
      locked_desc_en_attente:
        "The MO is awaiting validation. To modify this information, cancel the reintegration from the side panel.",
      locked_desc_valide:
        "The MO is already validated. To modify this information, cancel the reintegration from the side panel.",
      sur_ligne: "Quantity on line",
      sur_ligne_sub: "What you count",
      saisie_directe: "Direct entry",
      calcule: "Calculated",
      produit_ope: "Produced on this operation",
      produit_ope_sub: "What you manufactured",
      quantite_negative: "Negative quantity",
      erreur_prod: "Problem: production of",
      erreur_comptage_desc:
        "You counted #surLigne #unite on the line, but there were already #avantSaisie #unite before this operation.",
      erreur_comptage: "Counting error on the line",
      pertes_casses: "Undeclared losses or breakage",
      integration_double: "Double counted integration",
      resultat: "Resulting quantity produced on this operation:",
      total_apres_ope: "Total produced on the MO after this operation",
      objectif_of: "MO target",
      ope_precedente: "Previous operation",
      integre_sur_ope: "Integrated on this operation",
      produit_cette_ope: "Produced on this operation",
      votre_saisie: "your entry",
      total_apres: "Total after this operation",
      reste_a_produire: "Remaining to produce",
      of_termine: "MO completed!",
      represente_objectif: "This represents",
      de_objectif: "of the MO target",
      aide_title: "How does it work?",
      aide_desc:
        "Two ways to enter: either what you count on the line, or what you produced. The other value is calculated automatically.",
      formule_calcul: "Calculation formula:",
      detail_of: "Detail for this MO",
      avant_saisie: "Before your entry",
      produit_maintenant: "Produced on this operation",
      chiffres_collent: "Numbers don't add up?",
      chiffres_collent_desc:
        "Check if there were losses, undeclared breakage, or errors on previous operations.",
      aide_sur_ligne:
        "Count everything physically present on your production line.",
      formule: "Formula",
      aide_produit:
        "What you manufactured during this operation (excluding integrations).",
    },
    en_cours_production: "Currently in production",
    acceder_production: "Go to production",
    aucun_of_en_cours: "No MO currently in production",
    of_suivant: "Next MO",
    prevu_le: "Scheduled for",
    consulter_of: "View MO",
    aucun_of_prevu: "No MO scheduled",
    demarrer_ope: "Start operation",
    quantite_atelier: "Workshop quantity at end of operation",
    quantite_produite_ope: "Quantity produced during operation",
    generer_fiche: "Generate a sheet",
    etats_of: "MO status",
    lignes_production: "Production lines",
    dluo_filter: "BBD",
    date_filter: "Date",
    lot_pf_choix_title: "Finished product lot number",
    lot_pf_choix_description:
      "When production starts, a lot number is assigned to the finished product. You can create a new one, or reproduce an existing lot of this product (same number) — useful to continue a run or the same production batch.",
    lot_pf_choix_new_title: "Create a new lot",
    lot_pf_choix_new_subtitle: "An automatic lot number will be generated.",
    lot_pf_choix_reproduce_title: "Reproduce an existing lot",
    lot_pf_choix_reproduce_subtitle:
      "Reuse the number of a lot already produced for this finished product.",
    lot_pf_choix_select: "Lot to reproduce",
    lot_heritier_title: "Lot inheritance",
    lot_heritier_description:
      "A BOM line requires lot number inheritance. Please select the component lot whose number will be assigned to the produced lot.",
    lot_heritier_empty: "No lot available for this article.",
    lot_heritier_select: "Lot to inherit",
    lot_heritier_stock_positif: "Positive stock",
    lot_heritier_filter_adresse: "Address",
    lot_heritier_hide_dluo_depassee: "Hide expired BBD/UBD",
  },
  pdc: {
    incomplete: "Incomplete WIP",
    add_lot_cta: "Please select the lot and quantity to add to the WIP",
    no_conso: "No consumption",
  },
  cost: {
    create: "Create a cost",
    dateAlreadyExists: "A cost already exists for this date",
    edit: "Edit a cost",
    add: "Add a cost",
    noCosts: "No costs",
    title: "Cost tracking",
    locked: "Modified",
    dialog_add_revalorisation: "Add a revaluation",
    dialog_edit_revalorisation: "Edit the revaluation",
    btn_add_revalorisation_tooltip: "Add a new dated cost for this lot (previous history remains intact)",
    btn_cascade_impact: "View cascade impacts",
    btn_cascade_impact_tooltip: "Lists the lots and POs that use this lot — possibility to re-run the recalculation manually",
    source: "Source",
    source_type_of: "PO",
    source_type_reception: "Receipt",
    source_type_manuel: "Manual",
    source_type_revalorisation: "Revaluation",
    edit_origin_blocked: "Original cost — edit via the source",
    delete_origin_blocked:
      "Deletion forbidden: this cost comes from a source (production order / reception). Edit or delete the source to change it.",
    date_before_lot_creation: "Date cannot be earlier than the lot creation date.",
    date_already_exists: "A cost already exists for this date.",
    warn_from_of_title: "Original cost — computed from PO #source",
    warn_from_of_action: "To adjust this original cost, edit the material consumption or times of the corresponding PO.",
    warn_from_reception_title: "Original cost — from supplier order #source",
    warn_from_reception_action: "To adjust this original cost, edit the corresponding supplier order.",
    warn_alt_revalorisation: "Otherwise, you can add a revaluation at a later date.",
    warn_no_source_label: "This cost has a system origin that cannot be modified directly. You can add a revaluation at a later date.",
    btn_voir_of: "View PO",
    btn_voir_commande: "View order",
    cascade_dialog_title: "Cascade impacts",
    cascade_loading: "Loading…",
    cascade_error: "Unable to load impacts for this lot.",
    cascade_empty: "No downstream items. This lot is not consumed anywhere — modifying its cost will have no cascade impact.",
    cascade_explanation: "The following items use this lot in their production chain. A cost change is automatically propagated to all of them. The button below forces the recalculation if you have corrected a source data point.",
    cascade_ofs: "Production orders",
    cascade_lots: "Downstream lots",
    cascade_open_of_tooltip: "Open the PO",
    cascade_open_lot_tooltip: "Open the lot",
    cascade_trigger: "Run cascade recalculation",
    cascade_triggered: "Cascade recalculation started — downstream items will be recalculated shortly.",
    cascade_trigger_error: "Failed to trigger the recalculation.",
    commentaire_label: "Comment",
    commentaire_placeholder: "Ex: adjustment after inventory, raw material price correction…",
    commentaire_hint: "Optional — traces the revaluation reason for future audits",
  },
  vn: {
    search: "B12, Calcium...",
    add_cta: "Add a constant",
  },
  entity: {
    articles: "Articles",
    administration: "Administration",
    group: "Company",
  },
  misc: {
    by: "by",
    from_right: "From the rights of",
    other: "Other options",
    choice_scan: "Scan mode selection",
    use_camera: "Use camera",
    deport_camera: "Remote scan",
  },
  adresse: {
    numero: "Number",
    numeroComplement: "Number complement",
    voie: "Street",
    complement: "Address complement 1",
    complement2: "Address complement 2",
    cp: "Postal code",
    commune: "City",
    add_cta: "Add an address",
    search: "Search for an address",
    pays: "Country",
    livraisonDefaut: "Default delivery address for supplier orders",
    disabled: "Disabled",
    reactivate: "Reactivate",
  },
  pass: {
    label: "Permissions",
    choose_to_edit: "Choose permissions",
    create: "Add permissions",
    specifs: "Access to article list and specification viewing",
    lignes: "Access to production line list and editing",
    tiers: "Access to third party list and editing",
    stocks: "Access to stock list and editing",
    suivi_prod: "Access to production tracking",
    infos_journalieres: "Access to time entry",
    prod: "Access to MO list and editing",
    plannif_prod: "Access to production planning",
    stats_prod: "Access to production statistics",
    commandes: "Access to supplier orders and operations",
    commandesClient: "Access to customer orders and operations",
    redactionSpecif: "Can write specifications",
    validationSpecif: "Can validate specifications",
    approbationSpecif: "Can approve specifications",
    section_modules: "Module access",
    section_other: "Other permissions",
    widgets_section: "Per-widget permissions",
    cat_production: "Production widgets",
    cat_financier: "Financial widgets",
    cat_stock: "Stock widgets",
    cat_supervision: "Supervision widgets",
    cat_qualite: "Quality widgets",
    cat_ligne: "Line widgets",
    cat_article: "Article widgets",
    cat_tiers: "Third-party widgets",
    cat_user_infos: "Operator widgets",
    wProductiviteMoyenne: "Average productivity",
    wOfEnCours: "MOs in progress",
    wHeuresTravailles: "Hours worked",
    wQuantiteOf: "MO quantity",
    wOfList: "MO list",
    wSpecificationList: "Specification list",
    wQuantiteProduitePeriode: "Quantity produced per period",
    wCaCumule: "Cumulative revenue",
    wCaParPeriode: "Revenue per period",
    wCaDelta: "Revenue delta",
    wCaNMoins1: "Revenue Y-1",
    wRepartitionParClient: "Distribution by customer",
    wCommandeFournisseurList: "Supplier order list",
    wCommandeClientList: "Customer order list",
    wValeurParFamille: "Value by family",
    wLotParEtat: "Lots by status",
    wEvolutionValeur: "Stock value evolution",
    wPlanning: "Planning",
    wLiveProduction: "Live production",
    wNcStats: "NC statistics",
    wNcClosureMetrics: "NC closure metrics",
    wNcSupplierCompliance: "Supplier compliance",
    wQuantiteProduiteLigne: "Quantity produced (line)",
    wMainOeuvreLigne: "Labour (line)",
    wProductiviteLigne: "Productivity (line)",
    wCoutsLigne: "Costs (line)",
    wOfsLigne: "MOs (line)",
    wArticlesProduitsLigne: "Articles produced (line)",
    wConsosParArticle: "Consumptions per article",
    wProductions: "Productions",
    wAchats: "Purchases",
    wAchatsEvolution: "Purchase evolution",
    wVentes: "Sales",
    wMarge: "Margin",
    wHeuresOfs: "MO hours",
    wCaPeriodeArticle: "Revenue per period (article)",
    wCaCumuleArticle: "Cumulative revenue (article)",
    wMouvementsArticles: "Article movements",
    wStocksArticle: "Article stock",
    wQuickWin: "Quick Win",
    wAchatsEvolutionTiers: "Purchase evolution (third-party)",
    wVenteEvolutionTiers: "Sales evolution (third-party)",
    wCaCumuleTiers: "Cumulative revenue (third-party)",
    wCaParPeriodeTiers: "Revenue per period (third-party)",
    wMargeTiers: "Margin (third-party)",
    wAchatsTiers: "Purchases (third-party)",
    wVentesTiers: "Sales (third-party)",
    wCommandesTiers: "Supplier orders (third-party)",
    wCommandesClientsTiers: "Customer orders (third-party)",
    wHeuresUserInfos: "Hours (operator)",
    wRepartitionTravailUserInfos: "Work distribution (operator)",
    wOfsUserInfos: "MOs (operator)",
    wProductiviteUserInfos: "Productivity (operator)",
    wLignesUserInfos: "Lines (operator)",
    wArticlesProduitsUserInfos: "Articles produced (operator)",
    infoFinanciereOfLot: "Access to MO and Lot financial info",
    factures: "Access to billing",
    viewCoutArbreContributeurs: "View contributor names on cost tree",
    assistant: "Access to AI assistant",
  },
  article_fourni: {
    list_title: "Negotiated prices",
    sell: "Sales",
    buy: "Purchase",
    buy_sell: "All",
    edit: "Specific price modification",
    create: "Specific price creation",
    group: "Group",
    tiers: "Third party",
    default: "Default",
    link: "Link price to a third party or group",
    achetes: "Purchased articles",
    vendus: "Sold articles",
    specific_articles: "Specific article prices",
    specific_default: "Article price",
    specific_link: "Prices linked to a third party or group",
    add: "Add a price",
    show_prices: "View and edit prices",
    multiple_hint:
      "Suggested input multiple (e.g. a full pallet). If the entered quantity is not a multiple, a rounding will be proposed. Leave empty to disable.",
    prix_par_tranche: "Tiered pricing",
    prix_fixe: "Fixed price",
    apply: "Apply",
    warning_prix:
      "Price settings have changed, do you want to apply the modifications?",
  },
  remise: {
    title: "Discount",
    add: "Add a discount",
    edit: "Edit a discount",
    create: "Create a discount",
    tiers: "Third party",
    group: "Group",
    list_title: "Discounts",
    valeur: "Value",
    type: "Discount type",
    date_debut: "Start date",
    date_fin: "End date",
    article: "Article",
    link: "Link the discount to a third party or group",
    default: "Default",
    sans_limite: "No limit",
    periode: "Period",
    remises_appliquees: "Discounts",
    ajouter_manuelle: "Manual discount",
    total_avant_remise: "Total before discount",
    total_apres_remise: "Total after discount",
    montant_remise: "Discount amount",
    warning_remise: "Available discounts have changed",
    missing_remise: "Not all discounts for this customer are applied",
    appliquer_remises: "Apply discounts",
    pourcentage: "Percentage",
    montant_fixe: "Fixed amount",
    manuelle: "Manual",
    ajouter_liee: "Discount linked to article",
    ajouter: "Add",
    ajouter_remise: "Add a discount",
  },
  contact: {
    contactOf: "Contacts of ",
    add_cta: "Add a contact",
    emailConfirmationCommandeClient:
      "Recipient for customer order confirmations",
    emailBonCommandeFournisseur: "Recipient for supplier purchase orders",
  },
  infoPrix: {
    add_cta: "Add a price",
    create_cta: "Create a pricing grid",
    prix_maison: "These are the base prices for this article",
  },
  calendar: {
    add_cta: "Create a schedule",
    nameless: "Unnamed schedule",
  },
  calendar_event: {
    add_cta: "Add a time slot",
  },
  article: {
    qty_in: "Article quantity in",
    actions: "Article actions",
    select_new: "Select an article",
    showAll: "Show all articles",
    toolbox: "Quick actions",
    rescan: "Scan a new article",
    scan_no_corresponding_article: "No matching article found",
    make_fiche: "Generate a shipping unit sheet",
    bio: "Organic article",
    ddmAsNumeroDeLot: "Use the expiry date as lot number",
    ddmAsNumeroDeLot_hint:
      "When creating a lot in production (work order), the lot number is auto-generated from the expiry date (e.g. 311226 for 31/12/2026 with DD/MM/YY format). Useful for products where the date naturally identifies the lot. Otherwise, the number is a sequential counter.",
    vn: "Nutritional values",
    add: "Add an article",
    goToArticle: "Navigate to article",
    nbUnitePerPack: "Number of units per package",
    uniteComptage: "Counting unit",
    coefficientComptage: "Counting coefficient",
    valeurUnitaire: "Default unit value",
    quantiteParDimension: "Quantity per dimension",
    weight_suremballage: "Overwrap weight",
    refCalcul: "Quantity calculation reference",
    typeComptage: "Calculation type",
    tailleEchantillon: "Inventory sample size",
    secable: "Divisible product",
    new: "New article",
    code_auto: "Automatic reference assignment",
    ean_title: "Barcode",
    ddm_title: "Expiry dates",
    desc_title: "Descriptions",
    param_title: "Parameters",
    details_title: "Characteristics",
    ean13_auto: "Automatic EAN13",
    ean14_auto: "Automatic EAN14",
    duplication: "Duplicate an existing article",
    photo: "Article photo",
    etiquette: "Article label",
    details: "Details",
    article: "Article",
    add_label: "Add an article",
    add_cta: "Add an article",
    associate_cta: "Associate EAN13/14 to an additional article",
    associate_cta_code: "Create an article with this reference",
    edit_label: "Article modification",
    search: "Article name or code",
    search_add: "Search or add an article",
    isPrestation: "Pure service",
    is_alimentaire: "Food article",
    with_stock: "Stock-managed article",
    withStockPositif: "Ensure available stock for movements",
    withParallelOpe:
      "Ability to perform multiple simultaneous production operations",
    with_traca:
      "Mandatory traceability during production, when used as a component",
    with_lot: "Detail of stock quantities for each lot",
    with_lot_unique_warning:
      "For this article, single lot has been selected by default",
    info_gestion_conso:
      "Please select a consumption mode when this article is used as a component:",
    with_pdc:
      "Mandatory consumption entry with availability in MO component stock",
    with_conso_theoric: "Theoretical consumption",
    with_conso_volee:
      "Optional consumption entry (will use theoretical consumption if none declared)",
    with_specif: "Manufactured article",
    archived: "Archived article",
    with_emplacement: "With stock location",
    isAchete: "Purchasable article",
    isVendu: "Sellable article",
    withValeursNutritionnelles: "Article with nutritional values",
    stock: "Article stock",
    info_generales: "General info",
    process: "Process",
    nomenclature: "Article bill of materials",
    controles: "Controls",
    duplicate: "Duplicate an existing article",
    model: "Article specification",
    missing_current_version: "Being written",
    select: "Select an article",
    select_for_traca: "Select an article to display its traceability",
    type_article: "Article type",
    type_article_sub: "Optional, leave empty for a standard component",
    article_fabrique: "Manufactured article",
    article_fabrique_sub: "Finished or semi-finished product",
    permet_creation_of: "Allows creating manufacturing orders for this article",
    prestation_title: "Service",
    prestation_sub: "Service without physical stock",
    pas_gestion_stock: "No stock management",
    facturable_service: "Billable as a service",
    type_periode: "Period type",
    format_date: "Date format",
    format_date_dlc_jour_obligatoire:
      "An expiry date (DLC) must show the day (legal requirement).",
    type_date_limite_label: "Type of expiry date",
    type_date_limite: {
      ddm: "BBD — quality (warning)",
      dlc: "Expiry date — safety (blocking)",
      aucune: "None (non-perishable product)",
      ddm_hint:
        "Best Before Date: after this date, quality may degrade but consumption is still possible.",
      dlc_warning:
        "Expiry date (DLC): legal blocking after the date (FR R. 412-21 Consumer Code). Duration must be scientifically justified.",
      aucune_hint:
        "For non-perishable products (hardware, packaging, supplies…).",
      bascule_confirm_title: "Change the expiry date type?",
      bascule_confirm_message:
        "You are switching this article from #ancien to #nouveau.\n\nLots already in stock remain classified as #ancien (IFS audit consistency — a physically labelled lot cannot be retroactively reclassified). Only new lots created from now on will be handled as #nouveau.\n\nConfirm the change?",
    },
    dlc_format_auto_bascule:
      "Format switched to DD/MM/YYYY — expiry dates must show the day.",
    duree_conservation: "Duration",
    mode_gestion_stock: "Stock management mode",
    stock_global: "Global stock",
    stock_global_sub: "A single counter for this article",
    stock_lot_unique: "Stock managed in a single lot",
    lots_enregistres: "Supplier/manufactured lot numbers recorded",
    traca_amont_aval: "Upstream/downstream traceability available",
    suivi_lot_par_lot: "Lot-by-lot tracking",
    suivi_lot_par_lot_sub: "A separate stock for each lot",
    stock_lot_par_lot: "Stock managed lot by lot",
    conso_lot_par_lot: "Lot-by-lot consumption mandatory",
    composant_titre: "When this article is used as a component",
    traca_composant: "Component traceability",
    impose_lots_conso: "Requires declaring consumed lots",
    mode_consommation: "Consumption mode",
    theorique_title: "Theoretical",
    theorique_sub:
      "Consumption calculated automatically from the bill of materials. No input required.",
    declaration_consos: "Consumption declaration",
    declaration_consos_sub:
      "The operator declares quantities and lots consumed at each manufacturing step.",
    suivi_precis_consos: "Precise consumption tracking",
    suivi_precis_consos_sub:
      "Calculation by stock difference: materials are transferred to WIP before production, then an inventory at the end of the MO determines actual consumption.\nIdeal for detecting losses and yield variances.",
    pour_100ml: "Per 100 ml",
    pour_100g: "Per 100 g",
    unite_bis: "Secondary unit",
    unite_bis_placeholder: "The 20g bag",
    constante: "Constant",
    teneur: "Content",
    donnees_article: "Article data",
    donnees_inventaire: "Inventory data",
    photos_articles: "Article photos",
    telecharger_modele: "Download template",
    generer_ean13: "Generate an EAN13",
    importation_partielle: "Partial data import",
    selectionner_infos: "Select info",
    a_importer: "to import",
    info_vn:
      "To enter nutritional values, please fill in the following information",
    diametre_mandrin: "Mandrel outer diameter",
    diametre_rouleau: "Full roll diameter",
    epaisseur_produit: "Product thickness",
    laize: "Web width",
    non_suivi: "Not tracked",
    non_suivi_stock: "Article not tracked in stock",
    qte_unitaire: "Unit qty",
    informations_generales: "General information",
    jours: "Day(s)",
    mois_label: "Month(s)",
    annees: "Year(s)",
    impose_suivi_precis: "Requires precise consumption tracking mode",
    mouvements_bloques: "Movements are blocked if stock is insufficient",
    stocks_negatifs: "Negative stock is allowed (e.g. -5000 kg)",
    mode_incompatible_lot:
      'Incompatible with lot-by-lot traceability. Choose "Declaration" or "Precise tracking (PDC)".',
    declarations_modifiables:
      "Consumption declarations remain editable after closing in MO stats",
    coefficient: "Coefficient",
    inventaire_heading: "Inventory",
    logistique_heading: "Logistics",
    logistique_uc: "Consumer unit (CU)",
    logistique_colis: "Package",
    edit_weight_title: "Article weight",
    edit_weight_main: "Net weight CU",
    edit_weight_main_subtitle: "This weight is used to calculate the shipping unit weight",
    edit_weight_more: "More parameters",
    stock_heading: "Stock",
    donc_1_colis: "So 1 package =",
    donc: "So",
    comptage_simple_en: "Simple counting in",
    etats: "Statuses",
  },
  traca: {
    title_graph: "Traceability visualization",
    lastUpdate: "Updated on",
    why_no_graph:
      "The traceability chart is not yet available. It will be visible when the WIP is reintegrated",
    go_graph_of:
      "To view the traceability of this lot, please go to the corresponding MO page",
  },
  nomenclature: {
    title: "Quantities needed to manufacture one unit",
    empty: "No article in the bill of materials",
    add: "Add an article",
    add_ligne: "Add an article to the bill of materials",
    edit_ligne: "Bill of materials editing",
    select_article: "Select an article",
    select_article_default: "Select a default article",
    articleDynamic: "Configurable article",
    paramDynamic: "Configurable quantity",
    optional: "Optional",
    do: "Article used",
    dontDo: "Article not used",
    noNomenclature: "No article in the bill of materials",
    qttUndefined: "Quantity not defined",
    qttUnitaire: "i.e. #qtt for 1",
    perte_normale: "Normal loss",
    perte_maximale: "Maximum loss",
    lotHeritier: "Lot inheritance",
    lotHeritier_tooltip: "When the MO starts, the produced lot number will automatically match the lot selected for this component article.",
  },
  variable: {
    add_cta: "Add a parameter",
    edit_cta: "Edit a parameter",
    name: "Parameter name",
    type: "Parameter type",
    payload_default: "Default value",
    reset_default: "Reset",
    payload: "Value",
    dontDo: "Do not perform",
    missing_warning: "Parameters are missing, please modify the specification",
  },
  ij: {
    add_travail: "Add an entry",
    all_hours_completed: "All hours have been entered",
    hours_mismatch: "Paid hours and entered hours do not match",
    hour_entry_for: "Hour entry for",
    type_of: "WO",
    type_conges: "Leave",
    type_rtt: "RTT",
    type_maladie: "Sick leave",
    type_autres: "Other",
    entry_type: "Entry type",
    deletion_title: "Deletion",
    deletion_confirm: "You are about to delete the entered hours. This may impact productivity reports for different work orders. Do you confirm?",
    unknown_operator: "Unknown operator",
  },
  stock_article: {
    securite: "Safety stock",
    maximum: "Maximum stock",
    reappro: "Reorder threshold",
  },
  inventaires: {
    show_pdc: "View WIP containing this article",
    raz_entrepot: "Reset to 0",
    total_entrepot: "Total stock after warehouse inventory",
    par_entrepot: "by warehouse",
    label: "Inventory",
    add_cta: "Add an inventory",
    add_comptage: "Add a count",
    total: "Total inventoried",
    search_associate: "Search for an article to associate",
    cloture: "Inventory closure",
    confirm_raz:
      "The entered quantities will replace all stock for this article.\n" +
      "All lots and locations not entered will be reset to 0.\n" +
      "Do you want to continue?",
    confirm_only_those:
      "Only the stocks of entered lots at their locations will be updated.\n" +
      "All other lots and locations will remain unchanged.\n" +
      "Do you want to continue?",
    inventaire_confirm_raz:
      "The entered quantities will replace all stock.\n" +
      "All lots and locations not entered will be reset to 0.\n" +
      "Do you want to continue?",
    inventaire_confirm_only_those:
      "Only the stocks of entered lots at their locations will be updated.\n" +
      "All other lots and locations will remain unchanged.\n" +
      "Do you want to continue?",
    with_lot: "Inventory of stock quantities for each lot",
    with_lot_unique: "Inventory of overall stock quantities (not by lot)",
    supervision_parametres: "Supervision and settings",
    telecharger_csv: "Download CSV",
  },
  stock: {
    show_null_stock: "Show lots at 0",
    createEmplacement: "Create a new location",
    no_reinte: "Without reintegration",
    total: "Total stock",
    label: "Stock",
    zoneExpedition: "Shipping area",
    zoneNonConforme: "Non-compliant area",
    zoneQuarantaine: "Quarantine area",
    enDechargement: "Being unloaded",
    enDechargementInfo:
      "#nb unloading(s) in progress — not included in total stock. Perform the reception to integrate into stock.",
  },
  tiers: {
    tiers: "Third party",
    search: "Article owner (if article owned by a third party)",
    add_label: "Add a third party",
    add_cta: "Add a third party",
    edit_label: "Third party modification",
    abattement: "Discount",
    page: "Third party page",
    update_price: "Modify price",
    update_mail: "Update third party address",
    appartient: "Belongs to a third party",
    default: "Default",
    tier_group: "Group",
    tier_groups: "Groups",
    show_groups: "View groups",
    add_group: "Add a group",
    edit_group: "Edit a group",
    avecArticlesVendus: "Third parties with sold article info",
    avecArticlesAchetes: "Third parties with purchased article info",
    all: "All",
    showAll: "View all",
    aucun_groupe: "No group",
    est_transporteur: "Is a carrier",
    rib_paiement_default: "Default payment bank account",
    rib_paiement_aide: "This bank account will be automatically assigned to client invoices created for this third party. It can still be changed on each invoice.",
  },
  inventaire: {
    associate: "Associate to an existing article",
    new_article: "Create a new article",
  },
  mail: {
    visualize_bon_commande: "View the purchase order attached to the email",
  },
  document_list: {
    add_cta: "Add a comment",
    edit_cta: "Edit a comment",
    add_doc: "Add a document",
    new_doc: "New document",
    edit_doc: "Edit a document",
    element_deleted: "Element deleted",
    element_saved: "Saved",
    fullwidth_large: "Document size: large",
    fullwidth_small: "Document size: small",
  },
  dechargement: {
    pas_de_bl: "No delivery note",
    hint_bl: "Scan or import the delivery note, then enter its number. If you don't have a delivery note, skip to the next step.",
    hint_generaux: "Complete mandatory quality controls related to this unloading before entering received quantities.",
    hint_produits: "Enter received quantities for each article and complete associated quality controls.",
    previous: "Previous",
    next: "Next",
    save_draft: "Save as draft",
    finalize: "Finalize unloading",
    edit: "Edit",
    save_changes: "Save changes",
    articles_title: "Articles to unload",
    fill_from_commande: "Quantities as per order",
    fill_conforme: "Conforming quantities",
    no_controles: "No controls",
    controles: "Controls",
    in_progress: "In progress",
    ctrl_none: "No controls",
    ctrl_todo: "Controls to perform",
    ctrl_in_progress: "Controls in progress",
    ctrl_ok: "Controls OK",
    ctrl_nc: "NC detected",
    docs_title: "Comments & documents:",
    docs_add: "Add a comment or document",
    qty_ordered: "Ordered:",
    qty_already: "Already unloaded:",
    qty_unloaded: "Unloaded:",
    qty_remaining: "Remaining:",
    label: "Unloading",
    bl_prefix: "DN:",
    new_dechargement: "+ Unloading",
    add_dechargement: "Add an unloading",
    etat_termine: "Completed",
    etat_en_cours: "In progress",
    etat_reception_en_cours: "Reception in progress",
    n_articles: "articles",
    last_dech: "last unloading:",
    n_dech: "unl.",
    n_ref: "ref.",
    sort_newest: "Newest first",
    sort_oldest: "Oldest first",
    quit_title: "Leave unloading",
    quit_message: "Entered information has not been saved and will be lost.",
    quit_confirm: "Leave without saving",
    quit_cancel: "Stay on unloading",
    partial_delivery_title: "Partial delivery",
    partial_delivery_message: "The following articles have no quantity entered:",
    partial_delivery_confirm: "Validate without these articles",
    delete_title: "Delete unloading",
    delete_message: "The unloading and all its receptions will be deleted. Associated stock movements will be cancelled. Confirm?",
    warn_qty_inferior_title: "Warning — quantities below receptions",
    warn_qty_confirm: "Understood, save",
    error_no_quantity: "Enter at least one quantity to finalize the unloading",
    controles_incomplete_title: "Incomplete controls",
    finalize_anyway: "Finalize anyway",
    nc_detected_title: "Non-conformities detected",
    nc_confirm: "Validate despite NC",
    back_to_form: "Back to form",
    no_bl_title: "No delivery note number",
    no_bl_message: "No delivery note number has been entered. Do you want to continue without a delivery note?",
    no_bl_confirm: "Continue without DN",
    no_bl_cancel: "Enter a delivery note",
    save_and_continue: "Save and continue",
    save_and_quit: "Save and close",
    step_bl: "Delivery note",
    step_generaux: "General controls",
    step_produits: "Received products",
    pod_nothing_done: "Nothing completed",
    pod_all_ok: "All conforming",
    error_bl_required: "Enter a delivery note number or click No delivery note",
    error_generaux_required: "Complete all general controls before continuing",
  },
  reception: {
    qty_already: "Already received:",
    qty_remaining: "Remaining to receive:",
    qty_received: "Received:",
    add_lot: "+ Add a lot",
    print_id_sheet: "Print identification sheet",
    edit_notice: "Editing a saved reception. Quantities and lot will be corrected, a corrective stock movement will be generated automatically.",
    dechargement_nc_warning: "Unloading controls are non-conforming",
    lot_required: "Supplier lot number is required for this article",
    controles_required: "Quality controls must be completed before saving",
    incomplete: "Enter a quantity greater than 0",
    saved: "Reception saved",
    deleted: "Reception deleted",
    delete_title: "Delete this reception",
    delete_message: "Associated stock movements will be cancelled. Confirm deletion?",
    nc_title: "Non-conforming controls",
    nc_message: "Reception controls are non-conforming. Do you want to declare products as non-conforming?",
    nc_declare: "Declare non-conforming",
    nc_correct: "Correct quantity",
    save_next: "Next",
    finalize_and_receive: "Receive",
    tout_conforme: "Conforming",
    renseigner_lot: "Enter a lot",
    all_done: "All articles have been received",
    label: "Reception",
    auto: "Auto",
    ddm_prefix: "BBD",
    new_reception: "Reception",
    pending_count: "reception(s) pending",
    in_progress_count: "reception(s) in progress",
    done_count: "received",
    received: "Received",
    to_receive: "To receive",
    change_lot_title: "Change supplier lot",
    change_lot_confirm: "Change lot",
    controles_incomplete_title: "Incomplete controls",
    save_anyway: "Save anyway",
    back_to_form: "Back to form",
    fiche_palette: "Pallet sheet",
  },
  ligne: {
    add_label: "Add a production line",
    add_cta: "Add a production line",
    edit_label: "Production line modification",
    plannification: "Planning for line",
    plannification_select: "Choose a line to plan",
    search: "Production line",
    nbOF: "Maximum number of parallel MOs",
    missing_param_ligne1: "No line with the name: ",
    missing_param_ligne2: "has been set up for the technical family:",
    show_lignes: "View lines",
  },
  csv: {
    import: "Import CSV",
    import_article_fourni: "Import CSV for supplied articles",
  },
  cascade: {
    processing: "Recalculation in progress",
    uptodate: "Info up to date",
    refresh: "Update",
  },
  custom_enum: {
    add_option: "Add an option",
  },
  list: {
    empty: "No items",
    creer_liste: "Create a list",
    dupliquer: "Duplicate",
    lignes_concernees: "Relevant lines",
    ajouter_tache: "Add a task",
  },
  ordering: {
    valid: "Validate order",
  },
  process: {
    article: "Article processes",
    articleSub:
      "In production, the article processes will follow the specification processes",
    optional: "Optional process",
    do: "Perform the process",
    dontDo: "Do not perform the process",
    add_label: "Add a process",
    add_cta: "Add a process",
    edit_label: "Process modification",
    noProcess: "No process",
    from_template: "Create from a template",
    from_prompt_ai: "Create with AI",
    edit_mode_prompt_ai: "Edit with AI",
    edit_prompt_ai: "Edit AI instructions",
    exclude_lines: "Excluded lines",
    timer: "Timer",
    minute: "minute(s)",
    second: "second(s)",
    exclude_lines_exp:
      "Select the production lines for which the step should not be performed. (The step will not appear during productions on the selected lines.)",
  },
  processCopy: {
    quickCreate: "Quick create",
    processModel: "Process templates",
    searchSpecif: "Search in specifications",
    processIncorporation: "Article incorporation",
    variableUsage: "usage",
    variableUsages: "usages",
    in: "in",
    context: "context",
    contexts: "contexts",
    control: "Control",
    processDescription: "Process description",
    articleRef: "Bill of materials article",
    articleVarRef: "Configurable bill of materials article",
    varRef: "Variable",
    warn1:
      "The process contains references to variables or bill of materials articles.",
    warn2:
      "Please replace the found elements with elements from your specification.",
  },
  checklist: {
    all: "View all lists",
    who: "Users",
    frequence: "Frequency",
    add_label: "Add a checklist",
    edit_label: "Checklist modification",
    tolerancePlusMois: "Future tolerance (in hours)",
    toleranceMoinsMois: "Past tolerance (in hours)",
    tolerancePlusSemaine: "Future tolerance (in days)",
    toleranceMoinsSemaine: "Past tolerance (in days)",
    tolerancePlusJours: "Future tolerance (in minutes)",
    toleranceMoinsJours: "Past tolerance (in minutes)",
    deleted_suffix: "(deleted)",
    step_of_ope: "Select MO and operation",
    step_of: "Select MO",
    step_ope: "Select operation",
    step_controles_of: "MO-linked controls",
    step_controles: "Controls",
    controle_saved: "Control saved",
  },
  form: {
    select: "Select...",
    invalid: "The form is not valid",
    multiCheckbox: {
      removeAll: "Clear selection",
      select: "Select",
      selectLigne: "Line(s)",
      selectFamille: "Family(ies)",
      selectCategorie: "Sub-family(ies)",
    },
    minZero: "Must be >= 0",
    validators: {
      required: "This field is required.",
      minlength: "This field cannot be less than #min characters",
      maxlength: "This field cannot exceed #max characters",
      year: "The year is invalid",
      range: "CO2 emission ranges overlap",
      rangeLigne: "CO2 emission range is invalid",
      min: "This field must be greater than or equal to ",
      max: "This field must be less than or equal to ",
      length: "This must be #size #type",
      exactLength: "This field must contain #exactLength characters",
      email: "The email address is invalid",
      adresse: {
        cityPattern: "This is not a city name",
      },
      min_quantite: "This field must be greater than the minimum",
      stockSecuriteMax: "Safety stock cannot exceed reorder stock.",
    },
  },

  filters: {
    label: "Filters",
    no_data: "No data for the period / filters.",
    reset: "Reset filters",
  },
  tracabilite: {
    lot_unique_display:
      "Note: since this article's stock is not tracked by lot, the chart below is built only from traceability entries recorded on the various MOs linked to this lot. It shows the links between lots and MOs, but does not precisely reflect the actual consumption movements or exact quantities used.",
    tips_form:
      "You can select the article you want to trace right now.\n" +
      "\n" +
      "If you choose an article here: it will be automatically used when entering traceability.\n" +
      "\n" +
      "If you don't select anything: you will need to choose the article to trace at the time of entry.\n" +
      "\n" +
      "This gives you the flexibility to anticipate your choice or make it later, depending on your needs.",
  },
  planifComposant: {
    composants: "Components",
    stockActuel: "Stock at date",
    avecProvisoire: "With provisional orders",
    weekEvents: "Week events",
    dayEvents: "Day events",
    commandes: "Orders",
    commandesProvisoires: "Provisional orders",
    missingSeuil: "Threshold(s) not set",
    displayModeFlux: "Flow display mode",
    displayModeChart: "Chart display mode",
    editStock: "Edit stock parameters",
    showStock: "View stocks",
    createCommande: "Order",
    showCommandes: "View orders",
    articlesWithStock: "Stock-managed articles",
    articlesWithNoStock: "Non stock-managed articles",
    articlesWithoutEvent: "Articles without upcoming movements",
    articlesWithEvent: "Articles with upcoming movements",
    articlesOnlyReappro: "Articles to restock",
    triAlpha: "A-Z",
    triEvent: "Event",
    priority: "Priority",
    modeCommande: "Order",
    modePlanif: "Planning",
    noStock: "No stock",
    withoutStock: "Non stock-managed article",
    stock: "Stock",
    cumul: "Planned movement balance as of",
    noEventWeek: "No event planned for this week",
    noEventDay: "No event planned for this day",
    cancelCommandes:
      "You are about to delete your order draft. Do you confirm?",
    cancelCommandes_plural:
      "You are about to delete your #nb order drafts. Do you confirm?",
    events: {
      expedition: "Shipment",
      commandesClient: "Customer orders:",
      commandes: "Supplier orders:",
      ofsConso: "Consumed in:",
      ofsProd: "Produced by:",
      reception: "Reception",
      prod: "Prod.",
      conso: "Consumption",
      expeditionShort: "S",
      receptionShort: "R",
      prodShort: "P",
      consoShort: "C",
      prevu: "Reception",
      prevuShort: "R",
    },
  },
  planif: {
    performance: "Performance coefficient",
    addTacheCustom: "Add a task",
    addCloseCreneau: "Add a closure",
    dateDebut: "Start date",
    dateFin: "End date",
    customLigneName: "Category",
    tacheLibelle: "Label",
    affichage: "Display",
    eventTypes: "Event types",
    others: "Other filters",
    ligneIncompatible: "Incompatible line setting",
    deployLigne: "Please expand this line to drop the slot",
    of: {
      enCours: "MO in progress",
      planify: "Plan a MO",
      start: "Start a MO",
      startButton: "Start",
      planifyButton: "Plan",
      prevu: "Next planned MO",
      suivants: "Following MO(s)",
      select: "Select a MO",
      quantity_needed:
        "To perform certain calculations during the process, the specification requires the expected quantity.",
    },
    filter: {
      afficherHoraires: "Operating hours",
      afficherFermeture: "Ad hoc closures",
      hideLigneInactive: "Hide inactive lines",
      ligne: "Lines",
      famille: "Technical family",
      displayDays: "Scale",
      cacheWeeks: "Forecast",
      articleOrder: "Ordered articles",
      articleConso: "Consumed articles",
      articleProd: "Produced articles",
      articleExpe: "Shipped articles",
      fab: "Manufactured articles",
      nonFab: "Non-manufactured articles",
      fabNonFab: "Manufactured and non-manufactured articles",
      yes: "Yes",
      no: "No",
      all: "All",
      fabLabel: "Manufactured article",
      stockLabel: "Stock managed",
      eventLabel: "Planned movements",
    },
  },
  peo: {
    start: "Start recurring controls",
    stop: "End recurring controls",
    restart: "Restart recurring controls",
  },
  commandeClient: {
    associate_of: "Link a MO",
    livraison_sans_expedition: "Invoiced — kept in stock",
    desannuler: "Uncancel",
    confirmer: "Confirm the order",
    marquer_terminee: "Mark order as completed",
    reopen: "Reopen the order",
    etats_commande: "Order statuses",
  },
  widget: {
    add: "Add a widget",
    saveDashboard: "Save dashboard",
    production: "Production",
    financier: "Financial",
    of: "MO",
    commandeFournisseur: "Supplier order",
    commandeClient: "Customer order",
    specif: "Specification",
    list: "Lists",
    stopEdition: "Exit edit mode",
    stock: "Stock",
    select: "Select a widget",
    dluoDepassee: "BBD exceeded",
    dateValidation: "Validation date",
    dateRedaction: "Writing date",

    PRODUCTIVITE_MOYENNE: "Average productivity",
    OF_EN_COURS: "MOs in progress",
    HEURES_TRAVAILLES: "Worked hours",
    ARTICLES_PAR_FAMILLE: "Articles by family",
    QUANTITE_OF: "MO quantity",
    CADENCE_REELLE: "Actual rate",
    CA_CUMULE: "Cumulative revenue",
    CA_PAR_PERIODE: "Revenue by period",
    CA_DELTA: "Revenue delta",
    REPARTITION_PAR_CLIENT: "Distribution by customer",
    REPARTITION_PAR_FAMILLE: "Distribution by family",
    CA_N_MOINS_1: "Previous year revenue",
    VALEUR_STOCK: "Stock value",
    LOT_PAR_ETAT: "Lot by state",
    VALEUR_PAR_FAMILLE: "Value by family",
    ETAT_STOCK: "Stock state",
    NB_LOT_DLC: "Number of lots by use-by date",
    NB_COMMANDE_FOURNISSEUR: "Number of supplier orders",
    NB_COMMANDE_CLIENT: "Number of customer orders",
    MOUVEMENTS: "Stock movements",

    OF_ATTENTE_REINTEGRATION: "Awaiting reintegration",
    OF_ATTENTE_PDC: "Awaiting WIP",
    COMMANDE_CLIENT_EN_COURS_DE_TRAITEMENT: "Customer orders being processed",
    COMMANDE_CLIENT_EN_COURS_DE_PREPARATION: "Customer orders being prepared",
    COMMANDE_CLIENT_PRETE: "Ready",
    COMMANDE_FOURNISSEUR_EN_ATTENTE_ENVOI: "Supplier orders awaiting sending",
    COMMANDE_FOURNISSEUR_EN_ATTENTE_CONFIRMATION:
      "Supplier orders awaiting confirmation",
    COMMANDE_FOURNISSEUR_EN_ATTENTE_LIVRAISON:
      "Supplier orders awaiting delivery",
    COMMANDE_FOURNISSEUR_LIVREE_PARTIELLEMENT:
      "Supplier orders partially delivered",
    SPECIFICATION_REDIGEE: "Written specifications",
    SPECIFICATION_VALIDEE: "Validated specifications",
  },
  reinte: {
    recap: "Summary",
    edit_pdc: "Edit WIP",

    goPageReinte: "Refine material balance",
    finProduction: "End of production",
    saisirQuantitePourVoirBilan:
      "Enter a quantity to display the material balance",

    articlesConsommationManuelle: "Articles with declared consumption",
    articlesConsommationTheorique: "Articles with theoretical consumption",
    consoTheoriqueUnitaire: "Theoretical unit consumption",
    consoTheorique: "Theoretical consumption",
    consoReelle: "Actual consumption",
    ecart: "Variance",

    bilanOk: "Balance OK",
    ecartDetecte: "Variance detected",
    ecartImportant: "Significant variance",

    bilanPrecis: "Accurate consumptions",
    bilanPrecisDescription:
      "Declared consumptions match theoretical quantities. No action required.",

    ecartAVerifier: "Consumptions to verify",
    ecartAVerifierDescription:
      "Some consumptions slightly deviate from theoretical quantities. You can correct them if necessary.",

    ecartImportantTitre: "Significant variances detected",
    ecartImportantDescription:
      "Declared consumptions significantly differ from theoretical quantities. Check consumption entries.",

    corrigerConsommations: "Correct consumptions",

    calculAuto: "Auto calculation",
    articlesTheoriquesInfo:
      "These articles are consumed automatically according to the bill of materials. No entry declaration is required.",
    consommationTotaleTheorique: "Total theoretical consumption",

    resumeConsommations: "Consumption summary",
    imprimerBilan: "Print balance",
    quantiteRestanteAIntegrer: "Remaining quantity to integrate",
    quantiteIntegreeEnCours: "Quantity integrated during manufacturing",
    quantiteTotaleProduiteSurOf: "Total quantity produced on the MO",
    xEnregistrements: "record(s)",
    modifierInfosReinte: "Edit information",
    quantiteDepasse:
      "The entered quantity exceeds the available quantity on the line",
    quantiteIncoherente: "Inconsistent quantity",
    pfSurLigneCalcule: "FP available on the line",
    aideQuantiteDepassee:
      "The entered quantity is greater than the quantity of finished products actually on the line. Please correct the value to validate.",
    aideQuantiteRestante:
      "Quantity produced remaining on the production line, awaiting stock reintegration.",
    aideQuantiteIntegree:
      "Sum of quantities already transferred from WIP to stock during this MO manufacturing.",
    aideQuantiteTotale:
      "Total MO production: remaining quantity to integrate + quantity already integrated during manufacturing.",
    dateFinProduction: "Production end date",
    quantite: "Quantity",
    date: "Date",
    article: "Article",
    articles: "articles",
    etat: "State",
    total: "Total",
    consommesAuTotal: "consumed in total",
    validerFinProduction: "Validate end of production",
    aideSaisieConsos: "Consumption entry help",
    saisieConso: "Consumption entry",
    saisirConsos: "Enter consumptions",
    lotsSaisis: "lots entered",
    saisi: "Entered",
    aSaisir: "To enter",
    aucunLotPourCetArticle:
      "No lot found for this article in the reintegration balance.",
    sauvegarderProgression: "Save progress",
    validerEtFermer: "Validate and close",
  },
  help: {
    stockReappro:
      "Threshold below which a purchase order is recommended. Must be greater than or equal to safety stock.",
    stockSecurite:
      "Minimum stock to always maintain. Cannot exceed reorder stock.",
    quantiteAchat:
      "Default quantity proposed when creating a purchase order for this article.",
    net_weight_uc:
      "Net weight of one consumer unit (CU) in kg. This value is used to automatically calculate the total weight of shipping units.",

    article:
      "Product or component referenced in the company, which can be manufactured, purchased or stored. It has specific characteristics (name, code, management unit, EAN, etc.).",

    tiers:
      "External entity with which the company interacts, such as a customer, supplier or subcontractor.",

    specification:
      "Set of criteria defining the expected characteristics of an article (bill of materials, manufacturing process, controls to perform, etc.). Serves as a reference for manufacturing and quality control.",

    FAMILLE_ARTICLE:
      "Category grouping several articles with similar characteristics or the same purpose (e.g.: biscuits, sauces, packaging). Facilitates article organization and search.",

    SOUS_FAMILLE_ARTICLE:
      "Category grouping articles by their manufacturing or technical usage specifics (e.g.: types of raw materials, specific transformation processes). Allows structuring articles according to their compatibility with one or more manufacturing lines (rate, number of operators, etc.).",

    TRAVAIL:
      "Custom label for assigning work hours to specific operations (e.g.: warehouse cleaning, administrative support).",

    UNITE:
      "Custom management unit (e.g.: box of 24 units, 6L container), based on a base unit (Kg, Unit, Litre…) with an associated conversion coefficient.",

    OF: "Internal order triggering the production of an article, specifying the quantity to manufacture and the assigned production line. Used to organize, track and optimize manufacturing.",

    ope: "Subdivision of a Manufacturing Order (MO), allowing production to be executed in multiple steps. Corresponds to a specific quantity manufactured or a defined production period.",

    controles_simplifie:
      "In classic mode, controls are grouped by process steps (one step per stage, with multiple controls within).\n" +
      "\n" +
      "In simplified mode, each control directly becomes a stepper step.\n" +
      "The operator performs controls one by one, without going through the step concept.\n" +
      "\n" +
      "Advantages: simpler, smoother, less risk of forgetting.",
    customEnum: {
      FAMILLE_ARTICLE:
        "Allows categorizing articles by family (e.g.: components, finished products, packaging…).",
      SOUS_FAMILLE_ARTICLE:
        "Determines which line an article can be produced on, each line having its own settings adapted to sub-families.",
      UNITE:
        "Designates the unit in which the article is expressed (e.g.: piece, kilogram, litre).",
      UNITE_PROD:
        "Represents the production-specific unit for the article (e.g.: meter for cables).",
      EMPLACEMENT_STOCK:
        "Indicates the article's storage location (e.g.: shelf A1, warehouse B).",
      POSTE:
        "Represents the user's position (e.g.: manager, operator, technician).",
      TITRE:
        "Indicates the user's title or civility (e.g.: Mr., Mrs., Director).",
      TRAVAIL: "",
    },

    mode_conso:
      "These rules apply when closing a MO.\n" +
      "Afterwards, consumptions remain always modifiable in the MO statistics page.\n" +
      "\n" +
      "───────────────────────────\n" +
      "1) Article managed lot by lot\n" +
      "───────────────────────────\n" +
      'If the article is configured with "Detail of stock quantities for each lot",\n' +
      "then the consumption mode is imposed:\n" +
      "\n" +
      '"Precise consumption analysis (material balances / article tracked in WIP)"\n' +
      "\n" +
      "Why?\n" +
      "To maintain exact stock lot by lot, each consumption must be linked to a lot.\n" +
      "\n" +
      "Example:\n" +
      "Sugar (Lot S-001, Lot S-002) → consumption: 30 kg on S-001 + 20 kg on S-002.\n" +
      "\n" +
      "───────────────────────────\n" +
      "2) Article not managed by lot\n" +
      "───────────────────────────\n" +
      "Two modes are possible:\n" +
      "\n" +
      "A. Theoretical consumption\n" +
      "→ JustUp records the automatically calculated consumption.\n" +
      "Example: theoretical = 100 kg → retained consumption = 100 kg.\n" +
      "\n" +
      "B. Optional consumption entry\n" +
      "→ If nothing is entered: JustUp applies theoretical.\n" +
      "→ If a consumption is entered: it takes priority and replaces theoretical.\n" +
      "\n" +
      "Examples:\n" +
      "• Theoretical = 100 kg, entered = 96 kg → retained consumption = 96 kg\n" +
      "• Theoretical = 100 kg, nothing entered → retained consumption = 100 kg\n",
  },
  variables: {
    modelRedaction: "Unvalidated template",
    operator: "Operator",
    text: "Text",
    number: "Number",
    document: "Document",
    nomenclatureArticle: "Bill of materials",
    processOptional: "Optional process",
    optional: "Optional",
    articleDynamic: "Configurable article",
    paramDynamic: "Configurable quantity",
    do: "Perform",
    dontDo: "Do not perform",
    math_formula: "Numeric formula",
    text_formula: "Text formula",
  },
  nutrient: {
    calories: "Calories",
    total_fat: "Fat",
    saturated_fats_sub: "– of which saturated fats",
    trans_fats_sub: "– of which trans fats",
    omega3_sub: "– of which Omega-3",
    omega6_sub: "– of which Omega-6",
    monounsaturated_fats_sub: "– of which monounsaturated fats",
    carbohydrates: "Carbohydrates",
    dietary_fibre_sub: "– of which dietary fibre",
    soluble_fibre_sub: "– of which soluble fibre",
    insoluble_fibre_sub: "– of which insoluble fibre",
    sugars_sub: "– of which sugars",
    polyalcohols_sub: "– of which polyalcohols",
    starch_sub: "– of which starch",
    protein: "Protein",
    cholesterol: "Cholesterol",
    sodium: "Sodium",
    potassium: "Potassium",
    calcium: "Calcium",
    iron: "Iron",
    vitamin_a: "Vitamin A",
    vitamin_c: "Vitamin C",
    vitamin_d: "Vitamin D",
    vitamin_e: "Vitamin E",
    vitamin_k: "Vitamin K",
    thiamine: "Thiamine",
    riboflavin: "Riboflavin",
    niacin: "Niacin",
    vitamin_b6: "Vitamin B6",
    folate: "Folate",
    vitamin_b12: "Vitamin B12",
    biotin: "Biotin",
    pantothenate: "Pantothenate",
    choline: "Choline",
    phosphorus: "Phosphorus",
    iodide: "Iodine",
    magnesium: "Magnesium",
    zinc: "Zinc",
    selenium: "Selenium",
    copper: "Copper",
    manganese: "Manganese",
    chromium: "Chromium",
    molybdenum: "Molybdenum",
    chloride: "Chloride",
  },
  avoir: {
    add_cta: "Create a credit note",
  },
  tts: {
    regenerate: "Regenerate speech synthesis",
    autoplay: "Autoplay",
    autoplayLabel: "Autoplay speech synthesis",
  },
  connector: {
    title: "E-commerce connector",
    manageSync: "Manage synchronization",
    active: "Enabled",
    endpoint: "Endpoint",
    apiKey: "API key",
    typeConnector: "Connector type",
    clientId: "Client ID",
    state: "Synchronization state",
    sync: "Synchronize",
    loadingFrom: "Loading data from",
    errors: {
      necessite: "requires",
      compatible: "compatible",
      current: "current",
    },
    webhooks: {
      title: "Automation settings",
      description1Prestashop:
        "If you want to automatically synchronize elements when modified, created or deleted on Prestashop.",
      description2Prestashop:
        'Please configure the "Justup Webhooks" module for Prestashop.',
      download: "Download the Prestashop module",
      generateApiKey: "Generate an API key",
    },
    type: {
      customer: "Customer",
      customer_plural: "Customers",
      address: "Address",
      address_plural: "Addresses",
      product: "Article",
      product_plural: "Articles",
      order: "Order",
      order_plural: "Orders",
      group: "Group",
      group_plural: "Groups",
      specific_price: "Specific price",
      specific_price_plural: "Specific prices",
      toCreate: "to create",
      toReconcile: "to reconcile",
      diff: "to modify",
      synced: "already synchronized",
    },
    article_non_lie_chip: "Article not linked",
    article_non_lie_tooltip: "This article is not yet linked to #connectorName — the order cannot be sent until the article is linked",
    tiers_non_lie_chip: "Customer not linked",
    tiers_non_lie_tooltip: "#tiersName is not yet linked — this rate will not be sent to #connectorName",
  },
  time: {
    instant: "Just now",
    ago: "#time ago",
    dayShort: "d",
    hourShort: "h",
    minuteShort: "min",
  },
  pdf: {
    generate: "Generating PDF...",
  },
  sso: {
    sync: "Synchronize my account",
    configure_mail: "Configure",
    no_mail_configured: "No email is configured for your account",
    refresh: "Refresh connection",
    active: "Active",
    inactive: "Inactive",
    sendMail: "Email sending",
    yes: "Yes",
    no: "No",
    detail1:
      "For a faster and more reliable setup, we recommend using a Google or Microsoft account.",
    detail2:
      "If you prefer to use your own mail server, you can manually enter the SMTP settings below.",
    alreadyConfigured:
      "You already have a mail configuration, delete it to configure another one.",
  },
  "mouvements-stocks": {
    titre: "Stock movements",
    kpi: {
      entrees: "Inbound",
      sorties: "Outbound",
      "solde-net": "Net balance",
      mouvements: "Movements",
      "derniere-activite": "Last activity",
      "sur-la-periode": "over the period",
      "aucune-donnee": "No data",
    },
    filtres: {
      "interval-date": "Date range",
      rechercher: "Search by article, lot, link...",
      "type-mouvement": "Movement type",
      article: "Article",
      entrepot: "Warehouse",
      "effacer-filtres": "Clear filters",
    },
    periodes: {
      "1m": "1M",
      "3m": "3M",
      "12m": "12M",
      exercice: "Current fiscal year",
      "exercice-passe": "Previous fiscal year",
      tout: "All",
    },
    table: {
      type: "Type",
      date: "Date",
      article: "Article",
      lot: "Lot",
      lien: "Link",
      quantite: "Quantity",
      valeur: "Value",
      entrepot: "Warehouse",
      emplacement: "Location",
      documents: "Doc.",
      "elements-par-page": "Items per page",
      sur: "of",
      "aucun-mouvement": "No movement found",
      chargement: "Loading movements...",
    },
  },
  actions: {
    "exporter-csv": "Export CSV",
  },
  famille: {
    sousFamilles: "Sub-families",
    sousFamille: "sub-family",
    sousFamilles_plural: "sub-families",
    addSousFamille: "Add a sub-family",
    noSousFamille: "No sub-family",
    emptyList: "No items",
    showDisabled: "Show deactivated items",
    disableWarn:
      "This family is linked to old article versions, it cannot be permanently deleted.",
  },
  controle: {
    controlesGeneraux: "General controls",
    scope: {
      title: "Application scope",
      all: "This control applies to all items",
      filtered: "This control applies to filtered items",
      famille: "Article family",
      famille_plural: "Article families",
      sousFamille: "Article sub-family",
      sousFamille_plural: "Article sub-families",
      tiers: "Third party",
      allFeminin: "All",
      allMasculin: "All",
      or: "or",
      and: "and",
      selected: "#count selected",
      selected_plural: "#count selected",
      selectedMasculin: "#count selected",
      selectedMasculin_plural: "#count selected",
      familleCategorie: "Families and sub-families",
    },
    applique_uniquement: "Applied only for:",
    form: {
      min: "Min",
      max: "Max",
      saisies: "entries",
      minimumRequis: "minimum required",
      ajouterSaisie: "Add an entry",
      realisePar: "Done by",
      modifierRealisateur: "Change performer and date",
      cible: "Target",
    },
    matrix: {
      title: "Controls",
      controls_count: "controls",
    },
  },
  dynText: {
    general: "General",
    variables: "Variables",
    documents: "Documents",
    value: "Value",
    formula: "Formula",
    selectArticle: "Select an article...",
    number: "Number",
    dragHere: "Drag elements here or click on them...",
    selection: "Selection:",
    addDynamicValue: "Add a dynamic value",
    dynamicValues: "Dynamic values",
    ofQuantity: "MO quantity",
    opeQuantity: "Operation quantity",
    opeQuantityShort: "Op. quantity",
    name: "Name",
    reference: "Reference",
    code: "Code",
    quantity: "Quantity",
    quantityNomenclature: "Bill of materials quantity",
    unit: "Unit",
    unitManagement: "Management unit",
    loss: "Loss",
    lossNormal: "Normal loss (%)",
    lossMax: "Max loss",
    lossMaxPercent: "Max loss (%)",
    density: "Density",
    photo: "Photo",
    qtyOf: "MO qty",
    qtyOpe: "Op. qty",
    qty: "Qty",
    maxLoss: "Max loss",
    errorParenthesisClose: "Closing parenthesis without opening",
    errorStartOperator: "Cannot start with an operator",
    errorConsecutiveOperators: "Two consecutive operators",
    errorMissingOperator: "Missing operator between two values",
    errorOperatorAfterOpen: "Invalid operator after (",
    errorCloseAfterOperator: "Closing parenthesis after operator",
    errorMissingOperatorAfterClose: "Missing operator after )",
    errorMissingOperatorBeforeOpen: "Missing operator before (",
    errorUnbalancedParenthesis: "Unbalanced parentheses",
    errorEndOperator: "Cannot end with an operator",
    errorEndOpenParen: "Cannot end with (",
    selectElement: "Select an element",
    orSelectElement: "or select an element",
  },
  bilanArticle: {
    declarations: "Declarations",
    enregistrements: "record(s)",
    aideDeclarations:
      "Records are consumption declarations manually entered by operators on the line.",
    tracaWarning: "Traceability enabled but no declaration.",
    tracaWarningDetail: "Enter consumptions to ensure traceability.",
    theorique: "Theoretical",
    aSaisir: "To enter",
    aidePertes:
      "Variance between actual consumption and theoretical consumption expected by the bill of materials.",
    calculDesPertes: "Loss calculation",
    formulePertes: "Actual consumption − Theoretical consumption",
    soit: "i.e.",
    dEcart: "variance",
    seuilsConfigures: "Configured thresholds",
    seuilNormal: "Normal",
    seuilAttention: "Warning",
    seuilCritique: "Critical",
    modeTheorique: "Theoretical mode:",
    modeTheoriqueDetail: "no variance calculated (consumption = theoretical).",
    enAttenteDeSaisie: "Awaiting entry.",
    completezLots: "Complete lots to calculate losses.",
    entreePdc: "WIP INPUT",
    aideEntreePdc:
      "Total quantity transferred from stock to WIP for this MO. This is the material made available for production.",
    mouvement: "Movement",
    stockVersPdc: "Stock → WIP",
    total: "Total",
    consommation: "CONSUMPTION",
    aideConso:
      "Quantity actually consumed in production. Composed of operator declarations and automatic lot calculation.",
    repartition: "Distribution",
    declare: "Declared",
    calcule: "Calculated",
    theoriqueLabel: "Theoretical",
    saisieIncomplete: "Incomplete entry.",
    saisieIncompleteDetail: "Fill in all lots to get the total.",
    theo: "theo.",
    retourPdc: "WIP RETURN",
    aideRetourPdc:
      "Unused quantity returned from WIP to stock. This reintegration generates a 'WIP Reintegration' movement and allows recovery of excess materials.",
    calcul: "Calculation",
    pdcVersStock: "Movement: WIP → Stock",
    formuleRetour: "Input − Consumption = Return",
    retourAttenteDetail:
      "The return will be calculated automatically once all lots are entered.",
    reintegrationTitle: "Reintegration WIP → Stock",
    aideReintegration:
      "For each lot, enter the quantity actually returned to stock. The variance with the initial input will determine actual consumption.",
    parLot: "By lot",
    formuleConsoLot: "Consumption = WIP Input − Return",
    lotsASaisir: "lot(s) to enter",
    pourCompleterBilan: "to complete the balance.",
    saisieRetourPdc: "Enter the quantity returned to stock from WIP",
    ope: "Op.",
    du: "of",
    qteProduite: "Qty produced:",
    qteConsommee: "Qty consumed",
    qteTheorique: "Theoretical qty",
    lot: "lot",
    lot_plural: "lots",
  },
  bilanLot: {
    entreePdcLabel: "WIP Input",
    qteDisponible: "Available qty",
    aideQteInitialeReinte:
      "Quantity of this lot transferred from stock to WIP at the start of production.",
    ceLot: "This lot",
    stockVersPdc: "Stock → WIP",
    aideQteInitiale:
      "Available quantity of this lot at the start of this operation.",
    detail: "Detail",
    entreePdcDetail: "WIP Input:",
    reportPostePrec: "Prev. shift carry-over:",
    total: "Total:",
    qteRestanteFinProd: "Remaining quantity at end of production",
    qteRestanteFinOpe: "Remaining quantity at end of operation",
    aideRestanteReinte:
      "Unused quantity of this lot, returned to stock. Enter what physically remains after production.",
    aideRestanteOpe:
      "Unconsumed quantity of this lot at end of operation. This remainder will be carried over as available for the next operation.",
    saisieAttendue: "Expected entry",
    entre: "Between",
    et: "and",
    resultat: "Result",
    pdcVersStock: "WIP → Stock",
    retour: "Return:",
    consommation: "Consumption",
    aideConsoLot:
      "Quantity actually consumed for this lot, automatically calculated from input and return.",
    calcul: "Calculation",
    formuleEntreeRetour: "Input − Return = Consumption",
    saisirRetourPourCalcul: "Enter return to calculate",
    declarationsOperateur: "Operator declarations",
    declaration_plural: "declaration(s)",
    consosDifferentesDeclarations: "Consumption differs from declarations",
    consoNegative: "Negative consumption",
    estDifferentDes: "is different from the",
    declaresEnCoursProd: "declared during production",
    aideConsoDirecte:
      "Without WIP, directly enter the quantity consumed from this lot during production.",
    declarations: "Declarations",
    initiale: "INITIAL",
    disponible: "AVAILABLE",
    restante: "REMAINING",
    restanteFinOpe: "REMAINING END OP.",
    consommee: "CONSUMED",
    na: "N/A",
  },
  transfert_entrepot: {
    ajouterLigne: "Add a line",
    modifierLigne: "Modify line",
    zoneDeTransfert: "Transfer area",
    palettes: "Transfer with shipment",
    expedier: "Ship",
    envoyerVersChargement: "Send to loading",
    creerNouvellePalette: "Create a new shipping unit",
    palettesEnPreparation: "Preparation area",
    ajouterLignesAvant: "Please add lines to the transfer first",
    ajouterDesLots: "Add lots",
    preparationVrac: "Transfer area preparation",
    enZone: "In area",
    enZoneDeTransfert: "in area",
    lignesDeTransfert: "Transfer lines",
    article: "Article",
    quantite: "Quantity",
    numero: "Number",
    surPalette: "On shipping unit",
    expedie: "Shipped",
    demande: "Requested",
    stockDispo: "Available stock",
    mode: "Mode",
    adresseDepart: "Origin address",
    adresseArrivee: "Destination address",
    nouveauTransfert: "New warehouse transfer",
    modifierTransfert: "Modify transfer",
    creerPalette: "Create a shipping unit",
    ajouterDesLotsTitle: "Add lots",
    voirAutresPalettes: "View other shipping units",
    valider: "Validate",
    confirmerReception: "Confirm reception",
    annuler: "Cancel",
    desannuler: "Uncancel",
    solder: "Settle",
    nouveauTransfertBtn: "New transfer",
    transfertDu: "Transfer of",
    etatsTransfert: "Transfer states",
    trierParModification: "Sort by modification",
    trierParCreation: "Sort by creation",
    selectLotEtQuantite: "Select a lot and quantity to add",
    quantiteAAjouter: "Quantity to add",
    mouvementsEnAttente: "Pending movements to save",
    aucunMouvement: "No movement to save",
    sur: "of",
    annulationTitre: "Transfer cancellation",
    annulationMessage:
      "You are about to cancel transfer #numero. Do you confirm?",
    adressesIdentiques: "Origin and destination addresses cannot be the same",
    dluoDepassee: "Lot #numero BBD has expired, cannot select it",
    modifNonSauvegardees:
      "You have unsaved changes, do you really want to leave the page?",
    abandonnerModif: "Discard changes",
    resterSurPage: "Stay on page",
    attention: "Warning",
    paletteRequise: "Shipping unit is required for this transfer mode",
    preparation: "Preparation",
    imprimerBT: "Print transfer note",
    bonDeTransfert: "Transfer note",
    lot: "Lot",
    lots: "lots",
    expeditions: "Transfer preparation",
    vrac: "Direct transfer",
    dechargement: "Unloading",
    dechargementTitle: "Transfer unloading",
    nouveauDechargement: "New unloading",
    terminerDechargement: "Complete unloading",
    numeroBonTransfert: "Transfer note number",
    bonTransfert: "Transfer note",
    selectionnerBonTransfert: "Select a transfer note",
    reception: "Reception",
    receptionTitle: "Transfer reception",
    receptionsTitle: "Receptions",
    quantiteAttendue: "Expected quantity",
    quantitePresente: "Present quantity",
    quantiteRecue: "Received quantity",
    conforme: "Compliant",
    nonConforme: "Non-compliant",
    ecart: "Variance",
    recevoir: "Receive",
    recu: "received",
    quantiteDechargee: "Unloaded quantity",
    quantiteEnZone: "Quantity in transfer area",
    warningQuantiteSupZone:
      "The entered quantity exceeds the quantity in the transfer area",
    warningEcartQuantite:
      "Quantity variance: #expected expected, #actual present",
    warningEcartDechargement:
      "Variance: #decharged unloaded, #present present in area",
    warningArticleManquant: "Article not found in transfer area",
    warningArticleSupplementaire:
      "Article present in the transfer area but not planned in the transfer",
    aucuneReception: "No reception recorded",
    aucunDechargement: "No unloading recorded",
    progression: "Progress",
    modificationsEnCours: "Pending changes",
    presentsSurPalette: "Present on shipping unit",
    choisirArticle: "Click on an article to add lots",
    aide_expedition_maker:
      "Select an article to choose the lots and quantities to add to the shipping unit. The progress bar indicates progress relative to the requested quantity.",
    choisirPalette: "Choose a shipping unit",
    mettreSurPalette: "Place on shipping unit",
    preparationDuTransfert: "Preparation",
    paletteDu: "Shipping unit ·",
    vracDu: "Bulk ·",
    titre: "Warehouse transfers",
    titreDetail: "Warehouse transfer",
    termine: "Completed",
    enCours: "In progress",
    terminer: "Complete",
    du: "On",
    dechargementDuTransfert: "Transfer unloading",
    declarerLots: "Declare lots",
    recevoirLigne: "Receive",
    terminerDechargementTitle: "Complete unloading",
    terminerDechargementMessage: "Do you confirm the end of unloading?",
    dechargementTermine: "Unloading completed",
    receptionsEnregistrees: "Receptions saved",
    receptionModifiee: "Reception updated",
    receptionSupprimee: "Reception deleted",
    errorNoUserInfos: "Cannot save: user not loaded",
  },
  lot_stock_selector: {
    title: "Lot selection",
    titleStock: "Stock selection",
    placeholder: "Select a lot",
    placeholderStock: "Select a stock",
    selectionner: "Select",
    voirTousLesStocks: "View all stocks",
    quarantaine: "Quarantine",
    dluoDepassee: "BBD expired",
    aucunLot: "No lot available",
    aucunStock: "No stock available",
    aideTitle: "Selection",
    aideContent:
      "Available lots for this article are displayed below. Select the desired lot and validate.",
    aideAdresseFilter:
      "Only stocks from address #adresse are displayed. Enable the toggle to view all stocks.",
    lotUnique: "Single lot",
    voirLesLots: "View lots",
    ajouter: "Add",
    quantite: "Quantity",
    stockRestant: "Remaining stock",
    scanError: "Scanned lot not found in available options",
    ddm: "BBD",
    rechercherLot: "Search for a lot",
    rechercherStock: "Search for a stock",
    dispo: "available",
    stocksFiltresAdresse: "Only lots available in this warehouse are displayed",
    lotsEnStock: "lot(s) in stock",
    labelLot: "Lot",
    labelStock: "Stock",
    editTitle: "Edit quantity",
    currentOnPalette: "On shipping unit",
    modifier: "Edit",
  },
  parametrage: {
    expedition_unit_types: "Shipment units",
  },
  expedition_unit_type: {
    add: "Add a shipment unit type",
    edit: "Edit shipment unit type",
    denomination: "Name",
    denomination_hint: "E.g.: Euro pallet, Roll, Half-pallet",
    tare: "Tare (kg)",
    tare_hint: "Empty weight of the unit",
    valeur: "Value (€)",
    valeur_hint: "Unit value",
    article: "Linked article",
    article_aide:
      "Linking an article allows tracking the stock of available units in the warehouse.",
    icon: "Icon",
    gradient: "Color",
    stock_available: "in stock",
    no_article: "No linked article",
    delete_confirm: "Delete this unit type?",
    disabled: "Disabled",
  },
  palette_display: {
    status: {
      empty: "Empty",
      preparing: "Being prepared",
      ready: "Ready",
      waiting_shipment: "Awaiting shipment",
      shipped: "Shipped",
    },
    articles: "article(s)",
    weight: {
      net: "Net",
      tare: "Tare",
      brut: "Gross",
      missing: "Weight not specified",
      edit_weight: "Edit weight",
      enter_weight: "Enter weight",
    },
    action: {
      mark_ready: "Mark as ready",
      prepare: "Prepare",
      edit_palette: "Edit shipping unit",
      fiche: "Shipment sheet",
      print_sscc: "Print SSCC",
      edit_unit: "Edit unit",
      resume_preparation: "Resume preparation",
      link_expedition: "Link to a shipment",
      remove_from_bl: "Remove",
    },
    alert: {
      dlc_expired: "Use-by date exceeded",
      dlc_warning: "Use-by date approaching",
      weight_missing: "weight missing",
    },
    timeline: {
      created_by: "Created by",
    },
    expired_badge: "EXPIRED",
    shipped_on: "Shipped on",
    no_articles: "No articles",
    lots: "Lots",
    expedition_pending: "Shipment pending",
    delete_confirm: "You are about to delete this shipping unit. Do you confirm?",
    delete_title: "Deletion",
    controle_pod: "View POD control",
    controles: "Controls",
    print_bl: "Print delivery note",
    print_bt: "Print transfer note",
  },
  chargement_display: {
    title: "Loading of",
    transporteur: "Carrier:",
    print_fiches: "Print shipping unit sheets",
    add_palettes: "Add shipping units",
    export_pdf: "Export to PDF",
    print_bls: "Print delivery notes",
    print_bts: "Print transfer notes",
    declare_ready: "Declare as ready",
    declare_all_palettes_ready: "Declare all ready",
    declare_all_palettes_ready_success: "All shipping units are now marked as ready",
    empty_units_title: "No shipping unit",
    empty_units_message: "This loading has no shipping unit. Add at least one before loading.",
    load: "Load",
  },
  navbar: {
    reconnect: "Please reconnect",
    reading_badge: "Reading badge...",
    scan_badge: "Scan a badge",
    dark_mode: "Dark mode",
    light_mode: "Light mode",
  },
  user_card: {
    my_profile: "My profile",
    report_problem: "Report a problem",
    bug_title: "Have you encountered a bug?",
    bug_desc1: "We do our best to fix issues quickly.",
    bug_desc2:
      "Every piece of information is valuable. Don't hesitate to report what isn't working.",
    recording_desc1: "You can enable session recording",
    recording_desc2:
      "Once recording is enabled, try to reproduce the bug: it will help us better understand what happened.",
    recording_desc3: "Then, contact us via chat.",
    open_chat: "Open support chat",
  },
  substep_validation: {
    errors_title: "You have errors:",
    errors_blocking: "Errors are blocking for operation validation.",
    warnings_title: "You have warnings:",
    warnings_not_blocking:
      "Warnings are not blocking for operation validation.",
    step_validation_title: "Step validation #name",
    no_record_for_control: "No record for control #name",
    control_matrix_in_progress: "The control matrix is still in progress, do you want to finish it?",
    control_matrix_not_started: "The control matrix has not been started",
  },
  ips_input: {
    local: "local",
    authorized: "authorized",
    add_ip: "Add an IP",
  },
  dynamic_text: {
    general_elements: "General elements",
    operators: "Operators",
    nomenclature_elements: "Nomenclature elements",
    nomenclature_variable_elements: "Variable nomenclature elements",
    variables: "Variables",
    documents: "Documents",
    formula: "Formula",
    drop_in_formula: "Drop the element in the formula",
  },
  bon_livraison_display: {
    provisional: "Provisional delivery note",
    print_bl: "Print delivery note",
  },
  bon_transfert_display: {
    provisional: "Provisional transfer note",
    transfer_number: "Transfer #",
    print_bt: "Print transfer note",
  },
  expedies_filters: {
    transporteur: "Carrier",
    etat: "Status",
  },
  smtp_form: {
    delete_smtp: "Delete SMTP",
  },
  search_bar: {
    no_result: "No results",
  },
  qr_link: {
    creating: "Creating link...",
  },
  arborescence_etape: {
    etapes: "Steps",
  },
  tags: {
    add_placeholder: "Add a tag...",
  },
  user_infos_select: {
    label: "Users:",
    add_user: "Add a user",
  },
  widget_title: {
    theme: "Theme",
    remove: "Remove",
  },
  week_loader: {
    week: "Week",
  },
  multi_date: {
    date_interval: "Date range",
  },
  multi_checkbox: {
    all: "All",
  },
  input_search_dialog: {
    placeholder: "Search...",
  },
  embedded_expression: {
    size: "Size",
    alignment: "Alignment",
  },
  intext_embedded: {
    dynamic_values: "Dynamic values",
  },
  select_autocomplete: {
    suggestions: "Suggestions:",
  },
  chargement_selector: {
    title: "Select a loading",
  },
  cursor_tooltip_dialog: {
    title: "Add a dynamic value",
  },
  article_badges: {
    traca: "Traceability",
    pdc: "EOL",
    consos: "Consumption",
    auto: "Auto",
  },
  sankey: {
    zoom_in: "Zoom +",
    zoom_out: "Zoom -",
    recenter: "Recenter",
    fullscreen: "Fullscreen",
  },
  errors: {
    EXPEDITION_UNIT_TYPE: {
      SAVE_FAILED: "Unable to save shipment unit type",
      DELETE_FAILED: "Unable to delete shipment unit type",
      DENOMINATION_REQUIRED: "Name is required",
      NOT_FOUND: "Shipment unit type not found",
    },
    FACTURE: {
      NOT_FOUND: "Invoice not found",
      ALREADY_ISSUED: "This invoice is already issued.",
      EMPTY: "Cannot finalize an empty invoice.",
      ADDRESS_REQUIRED: "Please select a billing address",
      RIB_REQUIRED: "Please select a bank account (RIB) for this invoice",
      CHRONOLOGICAL_INCONSISTENCY:
        "Chronological inconsistency (#kind): the issue date #emissionDate is before the last issued document #lastNumero (#lastDate).",
      BL_INVALID: "Invalid delivery note",
      BL_ID_MISSING: "Delivery note ID missing",
    },
    QR: {
      MISSING_EAN14: "Cannot generate barcode: missing EAN14 in article",
      MISSING_LOT_NUMBER: "Cannot generate barcode: missing lot number",
      MISSING_PROD_DATE: "Cannot generate barcode: missing production date",
      MISSING_DLUO: "Cannot generate barcode: missing best before date (DLUO)",
      MISSING_COUNT: "Cannot generate barcode: missing shipping unit quantity",
      MISSING_NET_WEIGHT: "Cannot generate barcode: missing article net weight",
      MISSING_LOGISTIC_WEIGHT:
        "Cannot generate barcode: missing article logistic weight",
    },
    PALETTE: {
      NOT_FOUND_SSCC: "No shipping unit found for this SSCC",
      ALREADY_IN_BL: "This shipping unit is already assigned to another delivery note",
      EMPTY: "Cannot generate expedition sheet for an empty shipping unit",
      SELECT_AT_LEAST_ONE: "Please select at least one shipping unit",
      TRANSFERT_NOT_FOUND: "Warehouse transfer not found",
      ALREADY_SHIPPED: "Shipping unit #sscc has already been shipped",
    },
    TRANSFERT_ENTREPOT: {
      DUPLICATE_ARTICLE: "This article (and lot) is already in the transfer",
      VALIDATION_DATE_REQUIRED: "Please enter the validation date",
      EMPTY: "The transfer must contain at least one line",
      MUST_BE_AWAITING_SHIPMENT: "The transfer must be awaiting shipment",
      MUST_BE_SHIPPED_OR_PARTIAL:
        "The transfer must be in 'Shipped' or 'Partially transferred' state",
      NO_RECEPTION:
        "No reception recorded. Please complete unloading and reception before confirming.",
      QUANTITY_REQUIRED: "Please enter a quantity for each line",
      MISMATCH: "Transfer error",
      NOT_FOUND: "Transfer not found",
      NO_MOVEMENTS: "No movements to process",
      NO_LOTS_TO_SHIP: "No lots to ship",
      ZONE_NOT_FOUND: "Transfer zone not found for this transfer",
      STOCK_NOT_FOUND: "Stock not found",
      ARTICLE_NOT_RESOLVED: "Unable to determine the stock's article",
    },
    EXPEDITION_COMMANDE: {
      NOT_FOUND: "Client order not found",
      NO_MOVEMENTS: "No movements to process",
      NO_LOTS_TO_SHIP: "No lots to ship",
      COMMANDE_NOT_FOUND: "Client order not found",
      STOCK_NOT_FOUND: "Stock not found",
    },
    LOT: {
      NOT_FOUND: "Lot not found",
      INVALID_PAYLOAD: "No lot provided for saving",
      DUPLICATE_NUMBER:
        "A lot already exists with this number, please enter a different one",
      ARTICLE_NOT_FOUND_BY_EAN:
        "No article could be identified with this EAN14",
      SPECIFICATION_NOT_FOUND: "Specification not found for this article",
      FICHE_PALETTE_NO_LOT:
        "Cannot build the shipping unit sheet because no lot was provided",
    },
    LOT_MOUVEMENT: {
      NULL_MOVEMENT_LIST: "No movements to process",
      NULL_MOVEMENT: "There is a NULL movement",
      MISSING_DESTINATION_ADDRESS: "Destination address missing",
      MISSING_LOT: "Lot missing for reception",
      MISSING_ARTICLE: "Article missing for reception",
      ZERO_QUANTITY: "Please enter a non-zero quantity",
      MISSING_DEPARTURE_STOCK: "Departure stock missing",
      DEPARTURE_STOCK_NOT_FOUND: "Departure stock not found",
      MISSING_ARTICLE_REGROUPEMENT: "Article missing for regrouping",
      MISSING_STOCK_OR_ADDRESS: "Stock or address + lot missing for inventory",
      MISSING_OF_REFERENCE: "Work order reference missing for manufacturing",
      MISSING_ARTICLE_OR_LOT:
        "Article or lot missing for creation/manufacturing",
      MISSING_LOT_SELECTION: "Lot not selected for transfer",
      MISSING_PALETTE_OR_ADDRESS: "Shipping unit or arrival address missing",
      MISSING_COMMANDE_CLIENT:
        "Client order missing for expedition preparation",
      SAME_STOCK_TRANSFER: "Cannot transfer to the same stock",
      INSUFFICIENT_DEPARTURE_STOCK: "Insufficient departure stock for transfer",
      MISSING_DESTRUCTION_PARAMS: "Missing parameters for destruction",
      INSUFFICIENT_STOCK_DESTRUCTION: "Insufficient stock for destruction",
      MISSING_DELIVERY_PARAMS: "Missing parameters for delivery",
      INSUFFICIENT_STOCK_DELIVERY: "Insufficient stock for delivery",
      MISSING_SUPPLIER_RETURN_PARAMS: "Missing parameters for supplier return",
      INSUFFICIENT_STOCK_SUPPLIER_RETURN:
        "Insufficient stock for supplier return",
      MISSING_CLIENT_RETURN_PARAMS: "Missing parameters for client return",
      MISSING_CONSO_FAB_PARAMS:
        "Missing parameters for manufacturing consumption",
      CONSO_FAB_STOCK_NOT_FOUND: "Manufacturing consumption stock not found",
      INSUFFICIENT_STOCK_CONSO_FAB:
        "Insufficient stock for manufacturing consumption",
      MISSING_EXPEDITION_PARAMS: "Missing parameters for expedition",
      INSUFFICIENT_STOCK_EXPEDITION: "Insufficient stock for expedition",
      MISSING_EXPEDITION_TRANSFERT_PARAMS:
        "Missing parameters for transfer expedition",
      MISSING_TRANSFER_ZONE_ADDRESS: "Transfer zone address missing",
      MISSING_OWNER_CHANGE_QUANTITY: "Quantity missing for ownership change",
      MISSING_NEW_OWNER: "New owner missing for ownership change",
      LOT_NOT_FOUND: "Lot not found",
      ARTICLE_NOT_FOUND: "Article not found for this lot",
      INSUFFICIENT_ARTICLE_STOCK: "Insufficient stock for this article",
      MISSING_DEPARTURE_STOCK_FOR_LOT:
        "Departure stock required for lot-managed article",
      LOT_STOCK_NOT_FOUND: "No stock found for this lot at this address",
      INSUFFICIENT_LOT_STOCK: "Insufficient stock for this lot",
    },
    AUTH: {
      TOO_MANY_ATTEMPTS:
        "You have exceeded the allowed number of attempts. Please try again in #remainingSeconds seconds",
      IP_NOT_ALLOWED: "IP address not authorized",
      LOGIN_REQUIRED: "Please log in with your credentials",
      CREDENTIALS_REQUIRED: "Username and password are required",
    },
    TIERS: {
      IMPORT_MAINTENANCE: "Article supplier import is under maintenance",
      GROUPS_NOT_FOUND: "Group(s) not found",
    },
    TRANSACTION: {
      NOT_FOUND: "Transaction not found",
      PAYMENT_NOT_FOUND: "Payment not found",
      FACTURE_NOT_FOUND: "Invoice not found",
      INVALID_AMOUNT: "Transaction amount must be greater than 0",
      INVALID_PAIEMENT_AMOUNT: "Each payment amount must be greater than 0",
    },
    BON_TRANSFERT: {
      NOT_FOUND: "Transfer note not found",
    },
    BON_LIVRAISON: {
      NOT_FOUND: "Delivery note not found",
    },
    COMMANDE: {
      DUPLICATE_ARTICLE: "This article is already in the order",
      ERROR: "Order error",
    },
    POSTE: {
      CANNOT_DELETE_COMPLETED: "Cannot delete a completed workstation",
    },
    INVENTAIRE: {
      EMPTY: "The inventory is empty",
    },
    INTEGRATIONS: {
      NOT_FOUND: "Integration not found",
    },
    CRENEAU: {
      NO_SCHEDULE_FOUND: "No schedule found",
    },
    TRAVAIL: {
      DURATION_REQUIRED: "Please enter the duration for #label",
    },
  },
  stats: {
    ca_cumule: "Cumulative revenue",
    ca_par_periode: "Revenue by period",
    repartition_ventes: "Sales distribution by customer",
    repartition_achats: "Purchase distribution by supplier",
    repartition_marges_client: "Margin distribution by customer",
    repartition_marges_article: "Margin distribution by article",
    repartition_consos: "Consumption distribution by manufactured product",
    synthese_mouvements: "Movements summary",
    heures_par_user: "Hours worked by user",
    liste_ofs: "MO list",
    stock_actuel: "Current stock",
    quick_wins: "Quick wins",
    evolution_prix_vente: "Selling price evolution (weighted average)",
    evolution_prix_achat: "Purchase price evolution (weighted average)",
    repartition_articles_achetes:
      "Purchased articles distribution (by supplier)",
    date_interval: "Date interval",
    no_article_matching: "No matching article",
    commande_placeholder: "Order no…",
    client_placeholder: "Customer name…",
    fournisseur_placeholder: "Supplier name…",
    reference_placeholder: "Reference / label…",
    of_placeholder: "MO no, article, lot…",
  },
  dashboard_ui: {
    parametres: "Settings",
    actualiser: "Refresh widgets",
    ca_cumule_info:
      "Signed sum of HT totals across all issued invoices (credit notes deducted). Draft (provisional) invoices are excluded. Includes lines entered outside any shipment (shipping fees, services).",
    repartition_ca_info:
      "CA includes all invoice lines (credit notes deducted). Margin is only computed on lines linked to a shipment (trackable lot + cost). If part of the CA comes from non-shipped lines, the margin label shows the coverage.",
    modules: "Modules",
    ajoute: "added",
    ajouter_widget: "add",
    par_defaut: "Default dashboard",
    mon_dashboard: "My Dashboard",
    reinitialiser: "Reset my dashboard",
    specifications: "Specifications",
    productivite: "Productivity",
    heures_travaillees: "Hours worked",
    ofs_en_cours: "MOs in progress",
    ca_par_periode: "Revenue by period",
    ofs_en_attente: "Pending MOs",
    valeur_stock: "Stock value:",
    ca_cumule: "Cumulative revenue",
    ca_nmoins: "Revenue Y vs Y-1",
    delta_treso: "Cash flow delta",
    repartition_ca: "Revenue distribution",
    commandes_clients: "Customer orders",
    commandes_fournisseurs: "Supplier orders",
    status_ofs: "MO status",
    lots_par_etat: "Lots by status",
    repartition_defauts: "Defect distribution",
    repartition_temps: "Time distribution",
    granularite: "Granularity",
    echelle: "Scale",
    comparaison: "Comparison",
    aucune: "None",
    n_moins_1: "Y-1",
    periode_precedente: "Prev.",
    jour: "d",
    semaine: "w",
    mois: "m",
    annee: "y",
    quantite_produite_periode: "Quantity produced per period",
    toutes_lignes: "All",
    ligne: "Line",
    cat_production: "Production",
    cat_financier: "Financial",
    cat_stock: "Stock",
    cat_supervision: "Supervision",
    cat_ligne: "Line",
    w_productivite_moyenne: "Average productivity",
    w_ofs_en_cours: "MOs in progress",
    w_heures_travaillees: "Hours worked",
    w_quantite_ofs: "MO quantity",
    w_ofs: "MOs",
    w_specifications: "Specifications",
    w_quantite_produite_periode: "Quantity produced per period",
    w_ca_cumule: "Cumulative revenue",
    w_ca_par_periode: "Revenue by period",
    w_ca_delta: "Revenue delta",
    w_repartition_par_client: "Distribution by customer",
    w_commandes_fournisseurs: "Supplier orders",
    w_commandes_clients: "Customer orders",
    w_valeur_par_famille: "Value by family",
    w_lot_par_etat: "Lots by status",
    w_planning: "Planning (Upcoming activity)",
    w_planning_desc: "Cross-functional calendar view: supplier/customer orders, MOs, receptions, shipments…",
    w_live_production: "Live Production",
    w_live_production_desc: "Real-time shop floor supervision: line states, throughput, MOs, operators. Detachable window for 2nd screen.",
    w_quantite_produite: "Quantity produced",
    w_main_oeuvre: "Labor",
    w_productivite_ligne: "Productivity",
    w_couts_matiere_personnel: "Material / labor costs",
    w_ofs_ligne: "Line MOs",
    w_articles_produits: "Produced articles",
  },
  stats_ligne: {
    aucune_ligne: "No matching line",
    interval_date: "Date interval",
    aucune_donnee: "No data",
    stats_ligne_exercice_en_cours: "Current fiscal year",
    stats_ligne_exercice_passe: "Previous fiscal year",
    stats_ligne_tout: "All",
    utilisateur: "User",
    duree: "Duration",
    part: "Share",
    of: "MO",
    article: "Article",
    quantite: "Quantity",
    date_fin: "End date",
    score: "Score",
    quantite_produite_ligne: "Quantity produced",
    main_oeuvre_ligne: "Labor",
    productivite_ligne: "Productivity",
    couts_ligne: "Material / labor costs",
    ofs_ligne: "Line MOs",
    articles_produits_ligne: "Produced articles",
    aide_quantite_produite:
      "Sum of <span class='bold'>quantities produced</span> for each closed MO on the line, aggregated by period and grouped by <span class='bold'>management unit</span>.",
    aide_quantite_produite_formule:
      "For each period:<br/><span class='aide-formula'>Total = Σ quantityProduced (MOs)</span><br/>Use the unit selector to filter by product type (Kg, L, etc.).",
    aide_main_oeuvre:
      "Distribution of <span class='bold'>work time</span> entered by operator on the line's MOs.",
    aide_main_oeuvre_formule:
      "For each operator:<br/><span class='aide-formula'>Duration = Σ work durations</span><br/>The percentage is calculated on the cumulative total.",
    aide_productivite:
      "Productivity score by month, calculated as a <span class='bold'>weighted average</span> by quantities produced. Filterable by management unit.",
    aide_productivite_formule:
      "<span class='aide-formula'>Monthly score = Σ(score × qty) / Σ(qty)</span><br/>" +
      "MOs with large volumes weigh more.<br/>" +
      "<span class='valid bold'>Green</span> ≥ 95% · " +
      "<span class='warning bold'>Orange</span> 85–95% · " +
      "<span class='error bold'>Red</span> &lt; 85%",
    aide_couts:
      "Cumulative <span class='bold'>material</span> and <span class='bold'>labor</span> costs by month, stacked.",
    aide_couts_formule:
      "<span class='aide-formula'>Material = Σ actualMaterialCost (or theoretical)<br/>Labor = Σ actualLaborCost (or theoretical)</span><br/>" +
      "Actual costs take priority; if absent, theoretical costs are used.",
    aide_ofs:
      "List of all <span class='bold'>closed MOs</span> on the line within the selected period.",
    aide_ofs_formule:
      "Sortable by end date, quantity produced or score. Click on a row to access MO statistics.",
    aide_articles:
      "Distribution of <span class='bold'>quantities produced</span> by article on the line (top 12).",
    aide_articles_formule:
      "<span class='aide-formula'>Article share = Σ quantityProduced (article) / Σ total</span>",
    toutes: "All",
    calcul: "Calculation",
    score_moyen: "Average score (%)",
    quantite_produite_chart: "Quantity produced",
    n_moins_1: "Y-1",
    prec: "Prev.",
    label_quantite: "Quantity",
    label_matiere: "Material",
    label_personnel: "Labor",
    tri_date: "Date",
    tri_quantite: "Quantity",
    tri_score: "Score",
    tri_desc: "Desc",
    tri_asc: "Asc",
    tri_heures: "Sort by hours",
    tri_alpha: "Sort A-Z",
    inconnu: "Unknown",
    autres: "Others",
    heures: "Hours",
  },
  stats_user_infos: {
    aucun_operateur: "No matching operator",
    heures_travaillees: "Hours worked",
    total: "Total",
    repartition_travail: "Work type distribution",
    ofs_realises: "Completed MOs",
    ligne: "Line",
    productivite: "Productivity",
    lignes_travaillees: "Lines worked",
    articles_produits: "Produced articles",
  },
  expedition_commande: {
    maj_client: "Update in client",
  },
  horaires_form: {
    lundi: "Monday",
    mardi: "Tuesday",
    mercredi: "Wednesday",
    jeudi: "Thursday",
    vendredi: "Friday",
    samedi: "Saturday",
    dimanche: "Sunday",
    planning_perso: "Custom schedule",
    planning_defaut: "Default schedule",
    annuler_modification: "Cancel modification",
    modifier: "Edit",
  },
  logs_ui: {
    enregistrement_en_cours: "Recording in progress...",
    enregistrement_info: "Session recording can be used for debugging purposes",
    arreter_enregistrement: "Stop recording",
  },
  lignes_progress: {
    expedie: "Shipped",
    en_expedition: "In transit",
    sur_palette: "On shipping unit",
    a_preparer: "to prepare",
  },
  enums: {
    remise_type: {
      POURCENTAGE: "Percentage",
      MONTANT: "Fixed amount",
    },
    type_controle: {
      QCM: "MCQ",
      CNC: "Compliant / Non-compliant",
      QUANTITATIF: "Quantitative",
      MARQUAGE: "Marking or comparison",
      ENREGISTREMENT: "Recording",
      TRACABILITE: "Traceability",
    },
    element_type_controle: {
      LOT_RECEPTION: "Lot reception",
      PREPARATION_EXPE: "Shipment preparation",
      DECHARGEMENT: "Unloading",
      EXPEDITION: "Loading",
      LIBERATOIRE: "Release",
      CHARGEMENT: "Loading",
      PRODUCTION: "Production",
      START_OPE: "Operation start",
      END_OPE: "Operation end",
      START_OPE_GENERAUX: "At each operation start",
      END_OPE_GENERAUX: "At each operation end",
      LOT_RECEPTION_GENERAUX: "At each lot reception",
      PREPARATION_EXPE_GENERAUX: "At each shipment preparation",
      DECHARGEMENT_GENERAUX: "At each unloading",
      DECHARGEMENT_ARTICLE_GENERAUX: "At each article unloading",
      EXPEDITION_GENERAUX: "At each loading",
      LIBERATOIRE_GENERAUX: "At each release",
      CHARGEMENT_GENERAUX: "At each loading",
      PRODUCTION_GENERAUX: "At each production",
      PROCESS: "Process",
      SUIVI_LOT: "Lot lifecycle tracking",
      CHECKLIST: "Checklist",
    },
    type_nominal: {
      SUP: "Greater than",
      INF: "Less than",
      BETWEEN: "Between minimum and maximum",
    },
    etat_specification: {
      ARCHIVED: "Archived",
      EN_COURS: "Current",
      EN_REDACTION: "Drafting",
      REDIGEE: "Drafted",
      VALIDEE: "Validated",
      APPROUVEE: "Approved",
    },
    specification_variable_type: {
      NUMBER: "Number",
      STRING: "Text",
      DOCUMENT: "Document / Photo",
      NOMENCLATURE_ARTICLE: "Optional nomenclature",
      PROCESS_OPTIONAL: "Optional process",
    },
    transfert_entrepot_etat: {
      EN_REDACTION: "Drafting",
      EN_ATTENTE_EXPEDITION: "Awaiting shipment",
      EXPEDIEE: "Shipped",
      TRANSFEREE_PARTIELLEMENT: "Partially transferred",
      TERMINEE: "Completed",
      ANNULEE: "Cancelled",
      SOLDEE: "Settled",
    },
    transfert_entrepot_mode: {
      SIMPLE: "Simple",
      AVEC_EXPEDITION: "With shipment",
    },
    commande_etat: {
      EN_REDACTION: "Drafting",
      EN_ATTENTE_ENVOI: "Awaiting sending",
      EN_ATTENTE_CONFIRMATION: "Awaiting confirmation",
      EN_ATTENTE_LIVRAISON: "Awaiting delivery",
      ANNULEE: "Cancelled",
      LIVREE_PARTIELLEMENT: "Partially delivered",
      TERMINEE: "Completed",
      SOLDEE: "Completed (Settled)",
    },
    commande_client_etat: {
      EN_REDACTION: "Drafting",
      EN_ATTENTE_CONFIRMATION: "Awaiting confirmation",
      EN_ATTENTE_CONFIRMATION_MODIFIED: "Awaiting confirmation",
      EN_COURS_DE_TRAITEMENT: "In progress",
      EN_COURS_DE_PREPARATION: "Being prepared",
      PRETE: "Ready",
      EXPEDIE: "Shipped",
      EXPEDIE_PARTIELLEMENT: "Partially shipped",
      FACTURE_PARTIELLEMENT: "Partially invoiced",
      FACTURE: "Invoiced",
      ANNULEE: "Cancelled",
      TERMINE: "Completed",
    },
    etat_facture: {
      EN_REDACTION: "Drafting",
      EMISE: "Issued",
      PARTIELLEMENT_REGLEE: "Partially paid",
      REGLEE: "Paid",
      ANNULEE: "Cancelled",
      LITIGE: "Dispute",
      PARTIELLEMENT_CONSOMME: "Partially consumed",
      CONSOMME: "Consumed",
    },
    etat_transaction: {
      NON_AFFECTE: "Unassigned",
      PARTIELLEMENT_AFFECTE: "Partially assigned",
      AFFECTE: "Assigned",
    },
    type_transaction: {
      CB: "Card",
      VIREMENT: "Bank transfer",
    },
    famille_article: {
      FINI: "Finished",
      SEMIFINI: "Semi-finished",
    },
    unite_gestion: {
      KG: "Kilogram",
      G: "Gram",
      T: "Ton",
      ML: "Milliliter",
      L: "Liter",
      M3: "Cubic meter",
      UNITE: "Unit",
    },
    numero_complement: {
      BIS: "Bis",
      TER: "Ter",
      QUATER: "Quater",
    },
    periode_type: {
      FIN_DE_PERIODE: "End of period",
      NET: "Net",
    },
    type_tiers: {
      CLIENT: "Customer",
      FOURNISSEUR: "Supplier",
      CLIENT_FOURNISSEUR: "Customer and Supplier",
    },
    type_reglement: {
      ESPECE: "Cash",
      VIREMENT: "Bank transfer",
      PRELEVEMENT: "Direct debit",
      TRAITE: "Draft",
      LCR: "LCR",
    },
    delai_reglement: {
      LIVRAISON: "On delivery",
      COMMANDE: "On order",
      JOUR: "days",
      FDM: "end of month",
      FDD: "end of ten-day period",
    },
    of_etat: {
      ANNULE: "Cancelled",
      EN_ATTENTE_PLANNIF: "Awaiting scheduling",
      EN_ATTENTE_PROD: "Awaiting production",
      EN_ATTENTE_BILAN_MATIERE: "Awaiting material report",
      EN_PROD: "In production",
      EN_ATTENTE_REINTE_PDC: "Awaiting reintegration",
      EN_ATTENTE_VALIDATION: "Awaiting validation",
      VALIDE: "Completed",
    },
    etat_poste: {
      CALAGE: "Setting up",
      EN_COURS: "In progress",
      TERMINEE: "Completed",
      PENDING: "Pending",
      EN_ATTENTE_BILAN_MATIERE: "Awaiting material report",
    },
    type_mouvement: {
      RECEPTION: "Reception",
      RECEPTION_LOT_UNIQUE: "Reception (single lot)",
      RECEPTION_NON_CONFORME: "Non-compliant reception",
      INVENTAIRE: "Inventory",
      FABRICATION_LOT_UNIQUE: "Manufacturing (single lot)",
      FABRICATION: "Manufacturing",
      TRANSFERT: "Transfer",
      LIBERATION: "Release",
      CREATION: "Creation",
      LIBERATION_RECEPTION: "Reception release",
      DESTRUCTION: "Destruction",
      LIVRAISON: "Delivery",
      RETOUR_FOURNISSEUR: "Supplier return",
      RETOUR_CLIENT: "Customer return",
      CONSO_FAB: "Manufacturing consumption",
      PIED_DE_CHAINE: "End-of-line placement",
      REINTE_PIED_DE_CHAINE: "End-of-line reintegration",
      PREPA_EXPEDITION: "Shipment preparation",
      REINTE_EXPEDITION: "Shipment reintegration",
      EXPEDITION: "Shipment",
      PREPA_TRANSFERT: "Transfer preparation",
      REINTE_TRANSFERT: "Transfer reintegration",
      EXPEDITION_TRANSFERT: "Transfer shipment",
      REGROUPEMENT: "Grouping",
      RAZ: "Reset to zero",
      CHANGEMENT_PROPRIO: "Ownership change",
      INTEGRATION_EN_FABRICATION_LOT_UNIQUE: "In-process integration (single lot)",
      INTEGRATION_EN_FABRICATION: "In-process integration",
      REFUS_RECEPTION: "Reception refusal",
      CONSO_SUPPORT: "Shipping support consumption",
      REINTE_SUPPORT: "Shipping support reintegration",
      ENGAGEMENT_PREPA: "Prep zone engagement",
      LIBERATION_PREPA: "Prep zone release",
    },
    type_mouvement_short: {
      RECEPTION: "Reception",
      RECEPTION_LOT_UNIQUE: "Reception",
      RECEPTION_NON_CONFORME: "NC Reception",
      INVENTAIRE: "Inventory",
      FABRICATION_LOT_UNIQUE: "Manufacturing",
      FABRICATION: "Manufacturing",
      TRANSFERT: "Transfer",
      LIBERATION: "Release",
      CREATION: "Creation",
      LIBERATION_RECEPTION: "Rec. release",
      DESTRUCTION: "Destruction",
      LIVRAISON: "Delivery",
      RETOUR_FOURNISSEUR: "Supplier ret.",
      RETOUR_CLIENT: "Customer ret.",
      CONSO_FAB: "Mfg. cons.",
      PIED_DE_CHAINE: "EOL",
      REINTE_PIED_DE_CHAINE: "Reint. EOL",
      PREPA_EXPEDITION: "Ship. prep.",
      REINTE_EXPEDITION: "Reint. ship.",
      EXPEDITION: "Shipment",
      PREPA_TRANSFERT: "Transf. prep.",
      REINTE_TRANSFERT: "Reint. transf.",
      EXPEDITION_TRANSFERT: "Transf. ship.",
      REGROUPEMENT: "Grouping",
      RAZ: "Reset",
      CHANGEMENT_PROPRIO: "Ownership change",
      INTEGRATION_EN_FABRICATION_LOT_UNIQUE: "In-proc. integ.",
      INTEGRATION_EN_FABRICATION: "In-proc. integ.",
      REFUS_RECEPTION: "Rec. refusal",
      CONSO_SUPPORT: "Supp. cons.",
      REINTE_SUPPORT: "Reint. supp.",
      ENGAGEMENT_PREPA: "Engagement",
      LIBERATION_PREPA: "Release",
    },
    etat_palette: {
      PRETE: "Ready",
      EXPEDIEE: "Shipped",
      EN_PREPARATION: "Being prepared",
    },
    etat_chargement: {
      EN_PREPARATION: "Being prepared",
      PRET: "Ready for loading",
      CHARGE: "Loaded",
    },
    sexe: {
      HOMME: "Male",
      FEMME: "Female",
    },
    type_comptage: {
      POIDS_SURREMBALLAGE: "Weight with overwrap",
      DIMENSION: "Dimension / Weight",
      COMPTABLE_PACK: "Countable (pack/parcel)",
      SIMPLE: "Simple",
      ROULEAU_SURFACE: "Roll surface area",
      ROULEAU_LONGUEUR: "Roll length",
    },
    ref_calcul: {
      LONGUEUR_UC: "Length (Packaging unit)",
      LARGEUR_UC: "Width (Packaging unit)",
      HAUTEUR_UC: "Height (Packaging unit)",
      LONGUEUR_COLIS: "Length (Parcel)",
      LARGEUR_COLIS: "Width (Parcel)",
      HAUTEUR_COLIS: "Height (Parcel)",
      POIDS_NET_COLIS: "Net weight (Parcel)",
      POIDS_BRUT_COLIS: "Gross weight (Parcel)",
      POIDS_NET_UC: "Net weight (Packaging unit)",
      POIDS_BRUT_UC: "Gross weight (Packaging unit)",
    },
    type_list: {
      MOIS: "By day",
      JOUR: "By hour",
    },
    type_quick_inventaire: {
      RAZ_OTHER: "Reset other lots to 0",
      ONLY_THOSE: "Count only these lots",
    },
    date_schema: {
      JJMMAA: "DD/MM/YY",
      JJMMAAAA: "DD/MM/YYYY",
      MMAA: "MM/YY",
      MMAAAA: "MM/YYYY",
    },
    type_marquage_elem: {
      NUM_LOT: "Lot number of manufactured product",
      DLUO: "Best before date of manufactured product",
      NUMBER: "Digits",
      VARIABLE_STRING: "Variable characters",
      DATE_FAB: "Manufacturing date of product",
      SPACE: "Space",
      EAN13: "EAN 13 of manufactured product",
      EAN14: "EAN 14 of manufactured product",
      EAN128: "EAN 128 of manufactured product",
    },
    ai: {
      GTIN: "GTIN (01)",
      BATCH_LOT: "Batch/Lot (10)",
      PROD_DATE: "Production date (11)",
      BEST_BEFORE: "Best before (15)",
      USE_BY: "Use by (17)",
      NET_WEIGHT: "Net weight (3100)",
      LOGISTIC_WEIGHT: "Gross weight (3300)",
      REF: "Reference (240)",
    },
    role: {
      ADMIN: "Administrator",
      UTILISATEUR: "User",
    },
    type_fiche: {
      STANDARD: "Standard",
      CARTON: "Box",
      CARTON_EAN13: "Box EAN 13",
      LONG: "Tray",
    },
    type_connector: {
      PRESTASHOP: "PrestaShop",
    },
    state_connector: {
      WAITING_SYNC: "Awaiting synchronization",
      SYNCING: "Synchronization in progress",
      SYNC_ERROR: "Synchronization error",
      OK: "Synchronization OK",
    },
    sync_direction: {
      BOTH: "Both ways",
      PULL: "Receive",
      PUSH: "Send",
      NONE: "None",
    },
    validation_specif: {
      VALIDATION: "Approval and Validation",
      NONE: "No Validation",
    },
    validation_of: {
      SIMPLE: "Validation",
      DOUBLE: "Production and quality validation",
      NONE: "No validation",
    },
    validation_facture: {
      NUMEROTATION_AUTO: "Automatic numbering on shipment",
      CREATION_SANS_NUMEROTATION: "Invoice creation without numbering",
      NONE: "Manual invoicing",
    },
    type_idea: {
      BUG: "Bug",
      IDEA: "Idea",
    },
    type_custom_enum: {
      FAMILLE_ARTICLE: "Family",
      CATEGORIE_ARTICLE: "Sub-family",
      SOUS_FAMILLE_ARTICLE: "Technical family",
      UNITE: "Management unit",
      UNITE_PROD: "Unit",
      EMPLACEMENT_STOCK: "Stock location",
      POSTE: "Workstation",
      TITRE: "Title",
      TRAVAIL: "Work type",
    },
    dyn_text: {
      OF_QUANTITY_: "MO Quantity",
      OPE_QUANTITY_: "Op. Quantity",
      FAB_DENOMINATION_: "Manufactured article name",
      FAB_UNITE_: "Manufactured article unit",
      FAB_REF_: "Manufactured article reference",
      NAME_: "Name",
      DENSITY_: "Density",
      REF_: "Reference",
      QUANTITY_: "Nomenclature quantity",
      VAR_QUANTITY_: "Nomenclature quantity",
      LOSS_: "Normal loss (%)",
      MAXLOSS_: "Max. loss (%)",
      UNIT_: "Management unit",
      VAR_NAME_: "Name",
      VAR_DENSITY_: "Density",
      VAR_REF_: "Reference",
      VAR_LOSS_: "Normal loss (%)",
      VAR_MAXLOSS_: "Max. loss (%)",
      VAR_UNIT_: "Management unit",
      VAR_STRING_: "Text variable",
      VAR_N_: "Number variable",
      N_: "Quantity",
      X_: "×",
      DOC_: "Document",
      VAR_DOC_: "Document variable",
      ARTICLE_DOC_: "Article document",
      VAR_ARTICLE_DOC_: "Article document",
    },
  },

  relance: {
    dialog_title: "Dunning — invoice",
    btn_send: "Send",
    btn_record: "Record the reminder",
    btn_cancel: "Cancel",
    btn_next: "Next",
    btn_preview: "Preview letter",
    btn_relancer: "Send reminder",
    mail_dialog_title: "Compose reminder —",
    step1_title: "Choose the template",
    step2_title: "Delivery channel",
    field_canal: "Delivery channel",
    field_destinataires: "Recipients",
    field_cc: "Copy (CC)",
    field_objet: "Subject",
    field_corps: "Message",
    edit_target_mail: "E-mail",
    edit_target_courrier: "Letter",
    edit_target_hint: "The e-mail and letter texts can be customised independently. Use the toggle above to switch between them.",
    field_commentaire: "Internal note (not sent to the client)",
    canal_mail: "Email",
    canal_courrier: "Paper letter",
    canal_both: "Email + letter",
    niveau_rappel: "Friendly reminder",
    niveau_rappel_desc: "Sent 1 week before due date — very polite tone",
    niveau_1: "1st reminder",
    niveau_1_desc: "Due+7 — polite but firm",
    niveau_2: "2nd reminder",
    niveau_2_desc: "Due+21 — firm, ask for commitment",
    niveau_3: "3rd reminder",
    niveau_3_desc: "Due+45 — pressing, announce proceedings",
    niveau_demeure: "Formal notice",
    niveau_demeure_desc: "Due+60 — legal tone, statutory mentions",
    delai_label: "Due",
    suggested_badge: "Suggested",
    history_title: "Dunning history",
    no_history: "No reminders sent",
    sent_success: "Reminder sent",
    destinataires_required: "At least one recipient is required to send by email",
    courrier_preview_tooltip: "Open PDF letter preview",
    courrier_only_hint: "The PDF letter will be generated and downloadable. The reminder will be recorded in the history for tracking.",
    warn_not_due:
      "This invoice is not yet due (#days day(s) remaining). The selected dunning level is normally intended for overdue invoices.",
    warn_already_overdue:
      "This invoice is #days day(s) overdue. A simple courtesy note may not be sufficient — a higher level might be more appropriate.",
  },
};
